var _defs, _path, _g, _circle, _g2, _circle2, _circle3, _g3, _circle4, _circle5, _g4, _circle6, _circle7, _g5, _circle8, _circle9, _g6, _circle10, _circle11, _g7, _circle12, _circle13, _g8, _circle14, _circle15, _g9, _circle16, _ellipse, _g10, _circle17, _ellipse2, _g11, _circle18, _path2, _circle19, _g12, _circle20, _circle21, _g13, _circle22, _circle23, _g14, _circle24, _ellipse3, _g15, _circle25, _path3, _path4, _path5, _g16, _rect, _path6, _rect2, _g17, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g18, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "75 60 900 730",
    width: 900,
    height: 730,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 10.2)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#177bd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2061c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "d",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 15.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "e",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "f",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "g",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 14.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "h",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 2.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "i",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 15)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "j",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 22)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "k",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(.98 0 0 -.98 0 4.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "l",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(.98 0 0 -.98 0 5.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "m",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 13.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "n",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 7.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "o",
    cx: 0.5,
    cy: 0.5,
    gradientTransform: "matrix(1 0 0 -1 0 9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "p",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(.98 0 0 -.98 0 9.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "q",
    cx: 0.5,
    cy: 0.5
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.98 0 0 2.98 17 3.5)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ac9ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "u",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 -.1 .5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "v",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "scale(1.25)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "w",
    cx: 0.5,
    cy: 0.6,
    r: 1,
    gradientTransform: "matrix(.48 0 0 .48 -1.5 -.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "x",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "scale(1.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "y",
    cx: 0.5,
    cy: 0.5,
    r: 0.6,
    gradientTransform: "scale(.78)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "z",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "translate(-.5) scale(.49)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "A",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 .6 .6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "B",
    cx: 0.7,
    cy: 1.4,
    r: 0.4,
    gradientTransform: "matrix(1.33 0 0 1.26 179.9 81.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "C",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.48 0 0 .48 0 -.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "D",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.38 0 0 4.38 -.6 3.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "E",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.17 0 0 4.16 -1.3 2.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "F",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.5 0 0 .5 -.7 -.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "G",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 0 .5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "H",
    cx: 0.5,
    cy: 0.5,
    r: 36.3,
    gradientTransform: "matrix(.01 0 0 .01 -.5 -195.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "I",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.5 0 0 .5 0 -.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "J",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.2 0 0 4.2 26.6 2.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "K",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 .6 .6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "L",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.4 0 0 4.4 6.4 5.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "M",
    cx: 0.5,
    cy: 0.6,
    r: 1,
    gradientTransform: "matrix(.48 0 0 .48 -4.1 -6.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "N",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.26 0 0 1.26 .8 .8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "O",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.5 0 0 .5 -.3 -1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "P",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.1 0 0 4.1 3.5 4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "Q",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 .1 .7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "R",
    cx: 0.5,
    cy: 0.5,
    r: 27,
    gradientTransform: "matrix(.02 0 0 .02 -.9 -174.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "S",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.1 0 0 4.1 30 4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "T",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.5 0 0 .5 -.9 -1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "U",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 .8 .7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "V",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.4 0 0 4.41 19.8 9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "W",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.5 0 0 4.4 498.8 73.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "X",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.48 0 0 .48 -1.9 -3.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "Y",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.52 0 0 .51 -1.8 -3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "Z",
    cx: 0.5,
    cy: 0.5,
    r: 1,
    gradientTransform: "matrix(.52 0 0 .51 -1 -3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aa",
    cx: 0.5,
    cy: 1.1,
    r: 15.8,
    gradientTransform: "matrix(.03 0 0 .03 -1.8 -148.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ab",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(3.93 0 0 3.93 39 7.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ac",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 .5 1.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ad",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(3.94 0 0 3.93 15.2 7.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ae",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 1.2 1.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "af",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(4.29 0 0 4.3 83.6 27.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ag",
    cx: 0.4,
    cy: 0.4,
    r: 0.1,
    gradientTransform: "matrix(4.4 0 0 4.3 627.2 119)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ah",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.22 0 0 1.23 1.8 2.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ai",
    cx: 0.5,
    cy: 0.2,
    r: 1.1,
    gradientTransform: "matrix(.47 0 0 .47 -5.7 -17.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aj",
    cx: 0.5,
    cy: 0.7,
    r: 0.8,
    gradientTransform: "matrix(.59 0 0 .58 -4.5 -11.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ak",
    cx: 0.5,
    cy: 1.1,
    r: 6,
    gradientTransform: "matrix(.08 0 0 .08 -5.3 -120.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "al",
    cx: 0.5,
    cy: 0.6,
    r: 0.4,
    gradientTransform: "matrix(1.2 0 0 1.2 2 2.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "am",
    cx: 0.5,
    cy: 0.4,
    r: 0.2,
    gradientTransform: "matrix(3.27 0 0 3.29 39.7 18)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "an",
    cx: 0.5,
    cy: 0.6,
    r: 0.8,
    gradientTransform: "matrix(.59 0 0 .58 -5.8 -11.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ao",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(3.3 0 0 3.3 56.9 18)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ap",
    cx: 0.5,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.2 0 0 1.2 1.5 2.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aq",
    cx: 0.5,
    cy: 0.5,
    r: 0.7,
    gradientTransform: "matrix(.76 0 0 .76 -2.1 -.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ar",
    cx: 0.5,
    cy: 0.4,
    r: 0.5,
    gradientTransform: "matrix(1.04 0 0 1.09 5.6 3.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "as",
    cx: 0.5,
    cy: 0.5,
    r: 0.7,
    gradientTransform: "matrix(.76 0 0 .76 -1.8 -1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "at",
    cx: 0.5,
    cy: 0.8,
    r: 0.3,
    gradientTransform: "matrix(1.63 0 0 1.77 223.4 67)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "au",
    cx: 0.5,
    cy: 0.4,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 1.08 0 3.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "av",
    cx: 0.6,
    cy: 1.5,
    r: 0.3,
    gradientTransform: "matrix(2 0 0 2.04 377.5 98.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aw",
    cx: 0.5,
    cy: 0.5,
    r: 0.7,
    gradientTransform: "matrix(.76 0 0 .76 -1.3 -1.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ax",
    cx: 0.4,
    cy: 0.9,
    r: 0.4,
    gradientTransform: "matrix(1.14 0 0 1.14 14.9 7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ay",
    cx: 0.5,
    cy: 0.5,
    r: 0.7,
    gradientTransform: "matrix(.75 0 0 .75 -1.3 -1.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "az",
    cx: 0.4,
    cy: 0.3,
    r: 0.3,
    gradientTransform: "matrix(2 0 0 2.01 331.2 113)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aA",
    cx: 0.4,
    cy: 0.2,
    r: 0.4,
    gradientTransform: "matrix(1.14 0 0 1.14 12.7 8.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aB",
    cx: 0.5,
    cy: 0.4,
    r: 0.7,
    gradientTransform: "matrix(.75 0 0 .75 -1.8 -3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aC",
    cx: 0.5,
    cy: 1.3,
    r: 1,
    gradientTransform: "matrix(.5 0 0 .47 -92.8 -249)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aD",
    cx: 5.7,
    cy: 1.5,
    r: 0.1,
    gradientTransform: "matrix(7 0 0 4.4 26735.5 1015.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aE",
    cx: 0.5,
    cy: 0.7,
    r: 0.6,
    gradientTransform: "matrix(.85 0 0 .83 -9.1 -13.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aF",
    cx: 0.5,
    cy: 0.6,
    r: 1.6,
    gradientTransform: "matrix(.28 0 0 .33 -5.5 -14.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aG",
    cx: 0.5,
    cy: 0.4,
    r: 1.6,
    gradientTransform: "matrix(.32 0 0 .32 -4.4 -12.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aH",
    cx: 0.5,
    cy: 0.2,
    r: 0.4,
    gradientTransform: "matrix(1.18 0 0 1.25 48.8 45.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aI",
    cx: 0.5,
    cy: -0.4,
    r: 0.7,
    gradientTransform: "matrix(.67 0 0 .67 -33 -40.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aJ",
    cx: 0.5,
    cy: 0.6,
    r: 1.6,
    gradientTransform: "matrix(.32 0 0 .32 -3.1 -10)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aK",
    cx: 0.5,
    cy: -0.5,
    r: 0.4,
    gradientTransform: "matrix(1.3 0 0 1.27 78.9 45.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aL",
    cx: 0.6,
    cy: 0.6,
    r: 0.7,
    gradientTransform: "matrix(.73 0 0 .7 -24.1 -33.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aM",
    cx: 0.5,
    cy: 1.4,
    r: 0.3,
    gradientTransform: "matrix(1.56 0 0 1.5 140.7 74.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aN",
    cx: 0.5,
    cy: 0.4,
    r: 1.5,
    gradientTransform: "matrix(.33 0 0 .33 -2.9 -10.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aO",
    cx: 0.5,
    cy: 1.2,
    r: 0.7,
    gradientTransform: "matrix(.76 0 0 .74 -18.6 -27.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aP",
    cx: 0.5,
    cy: 0.5,
    r: 1.5,
    gradientTransform: "matrix(.34 0 0 .35 -3.7 -14.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aQ",
    cx: 0.5,
    cy: -0.4,
    r: 0.3,
    gradientTransform: "matrix(1.75 0 0 1.74 187.2 104.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aR",
    cx: 0.5,
    cy: -0.2,
    r: 0.6,
    gradientTransform: "matrix(.8 0 0 .79 -14 -21.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aS",
    cx: 0.5,
    cy: -0.6,
    r: 0.5,
    gradientTransform: "matrix(.9 0 0 .88 -16.8 -28.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aT",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.02 0 0 2.01 11.9 9.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aU",
    cx: 0.5,
    cy: 0.9,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 .99 0 -1.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aV",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.05 0 0 2.05 11 8.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aW",
    cx: 0.5,
    cy: 1.4,
    r: 1.9,
    gradientTransform: "matrix(.25 0 0 .24 -97.5 -748.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aX",
    cx: 0.5,
    cy: 0.3,
    r: 0.6,
    gradientTransform: "matrix(.87 0 0 .87 -11.2 -19.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aY",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.11 0 0 2.1 9 6.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "aZ",
    cx: 0.5,
    cy: -0.1,
    r: 0.5,
    gradientTransform: "matrix(.92 0 0 .96 -14 -11.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ba",
    cx: 0.4,
    cy: 0.2,
    r: 0.4,
    gradientTransform: "matrix(1.42 0 0 1.43 41.3 43.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bb",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.06 0 0 2.04 8.5 5.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bc",
    cx: 0.5,
    cy: 0.1,
    r: 0.4,
    gradientTransform: "matrix(1.14 0 0 1.19 11.4 18.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bd",
    cx: 0.5,
    cy: 0.4,
    r: 0.3,
    gradientTransform: "matrix(1.96 0 0 1.97 11.4 7.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "be",
    cx: 0.3,
    cy: 3.3,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.21 151 112.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bf",
    cx: 0.5,
    cy: 1,
    r: 0.5,
    gradientTransform: "matrix(.95 0 0 .95 -3 -4.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bg",
    cx: 0.4,
    cy: 0.2,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 .99 0 -2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bh",
    cx: 0.5,
    cy: 3,
    r: 0.7,
    gradientTransform: "matrix(.7 0 0 .7 -50.1 -96.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bi",
    cx: 0.5,
    cy: 0.5,
    r: 0,
    gradientTransform: "matrix(13.25 0 0 13.53 1135.8 7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bj",
    cx: 0.5,
    cy: 0.4,
    r: 0,
    gradientTransform: "matrix(12.31 0 0 12.53 1048.9 26.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bk",
    cx: 0.5,
    cy: 0.5,
    r: 0,
    gradientTransform: "matrix(17.19 0 0 17.54 1500.9 45.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bl",
    cx: 0.5,
    cy: 0.5,
    r: 0,
    gradientTransform: "matrix(14.25 0 0 14.53 1228.5 68.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bm",
    cx: 0.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(8.75 0 0 8.91 718.6 85.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bn",
    cx: 0.5,
    cy: -0.2,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.22 55.8 43.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bo",
    cx: 0.5,
    cy: -1.4,
    r: 0.6,
    gradientTransform: "matrix(.88 0 0 .91 -28 -27.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bp",
    cx: 0.5,
    cy: -4.3,
    r: 1.3,
    gradientTransform: "matrix(.38 0 0 .42 -139.6 -550.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bq",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.01 0 0 2.01 3.2 9.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "br",
    cx: 0.5,
    cy: 1.2,
    r: 0.7,
    gradientTransform: "matrix(.7 0 0 .7 -10.3 -73.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bs",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.04 0 0 2.03 4.3 8.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bt",
    cx: 0.5,
    cy: 2.8,
    r: 1.2,
    gradientTransform: "matrix(.4 0 0 .4 -36.8 -363.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bu",
    cx: 0.5,
    cy: 0.8,
    r: 0.5,
    gradientTransform: "translate(0 .6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bv",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.06 0 0 2.06 4.5 6.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bw",
    cx: 0.5,
    cy: 5,
    r: 1.9,
    gradientTransform: "matrix(.25 0 0 .23 -49.1 -709.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bx",
    cx: 0.5,
    cy: 1,
    r: 0.6,
    gradientTransform: "matrix(.87 0 0 .87 -5.4 -18.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "by",
    cx: 0.8,
    cy: 0.5,
    r: 0.4,
    gradientTransform: "matrix(1.2 0 0 1.27 73.5 128.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bz",
    cx: 0.5,
    cy: 0.5,
    r: 0.2,
    gradientTransform: "matrix(2.04 0 0 2.05 6.1 5.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bA",
    cx: 0.5,
    cy: 0.9,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 1.06 0 6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bB",
    cx: 0.5,
    cy: 0.5,
    r: 0.3,
    gradientTransform: "matrix(1.99 0 0 1.98 10.8 7.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bC",
    cx: 0.2,
    cy: -2.1,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 1.22 0 153.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bD",
    cx: 0.5,
    cy: 0.2,
    r: 0.6,
    gradientTransform: "matrix(.9 0 0 .91 -5.3 -9.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bE",
    cx: 0.5,
    cy: 1.6,
    r: 0.4,
    gradientTransform: "matrix(1.38 0 0 1.24 81 44)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bF",
    cx: 0.6,
    cy: -0.5,
    r: 0.3,
    gradientTransform: "matrix(1.67 0 0 1.48 213.7 99.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bG",
    cx: 0.4,
    cy: -1.6,
    r: 0.6,
    gradientTransform: "matrix(.75 0 0 .89 -57.6 -41.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bH",
    cx: 0.5,
    cy: 0.6,
    r: 1.5,
    gradientTransform: "matrix(.32 0 0 .32 .9 -12.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bI",
    cx: -1.1,
    cy: 2.6,
    r: 0.1,
    gradientTransform: "matrix(4 0 0 4.28 3718.2 1027.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bJ",
    cx: 0.5,
    cy: 0.4,
    r: 1.5,
    gradientTransform: "matrix(.33 0 0 .32 .2 -12.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bK",
    cx: 0.6,
    cy: 1.4,
    r: 0.4,
    gradientTransform: "matrix(1.17 0 0 1.25 18.2 92.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bL",
    cx: 0.5,
    cy: 0.7,
    r: 0.6,
    gradientTransform: "matrix(.9 0 0 .9 -.3 -11.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bM",
    cx: 0,
    cy: 0.8,
    r: 0.1,
    gradientTransform: "matrix(5.5 0 0 4.36 4667.1 691.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bN",
    cx: 0.5,
    cy: 0.5,
    r: 1.6,
    gradientTransform: "matrix(.32 0 0 .32 -.4 -10)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bO",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    gradientTransform: "matrix(1.25 0 0 1.25 85.7 135.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bP",
    cx: 0.4,
    cy: -0.1,
    r: 0.5,
    gradientTransform: "matrix(1.1 0 0 1.02 2.4 2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bQ",
    cx: 0.5,
    cy: 0.6,
    r: 1.5,
    gradientTransform: "matrix(.32 0 0 .32 -1.3 -10.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bR",
    cx: 0.7,
    cy: 1.6,
    r: 0.4,
    gradientTransform: "matrix(1.2 0 0 1.26 62.2 107.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bS",
    cx: 1.6,
    cy: 1.2,
    r: 0.1,
    gradientTransform: "matrix(4.5 0 0 4.43 4928 843.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bT",
    cx: 0.5,
    cy: 0.1,
    r: 0.5,
    gradientTransform: "matrix(.95 0 0 .95 -1.9 -4.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bU",
    cx: 2.5,
    cy: 0.5,
    r: 0.1,
    gradientTransform: "matrix(3.5 0 0 4.38 4788 1088.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bV",
    cx: 0.5,
    cy: 0.5,
    r: 1.5,
    gradientTransform: "matrix(.34 0 0 .34 -3 -15.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bW",
    cx: 0.4,
    cy: 2.1,
    r: 0.4,
    gradientTransform: "matrix(1.33 0 0 1.22 92.9 59.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bX",
    cx: 0.5,
    cy: 0.2,
    r: 0.6,
    gradientTransform: "matrix(.87 0 0 .86 -6.5 -13.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bY",
    cx: 0.5,
    cy: 2,
    r: 0.5,
    gradientTransform: "matrix(.9 0 0 .97 -16.6 -7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "bZ",
    cx: 0.7,
    cy: -0.5,
    r: 0.3,
    gradientTransform: "matrix(1.67 0 0 1.5 214.2 101)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ca",
    cx: 0.7,
    cy: -0.2,
    r: 0.2,
    gradientTransform: "matrix(2.25 0 0 1.9 710.8 213.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cb",
    cx: 0.5,
    cy: 0.5,
    r: 0.7,
    gradientTransform: "matrix(.77 0 0 .77 .1 -.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cc",
    cx: 0.5,
    cy: 1.2,
    r: 0.5,
    gradientTransform: "matrix(1.1 0 0 1.04 .4 1.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cd",
    cx: 0.5,
    cy: 0.6,
    r: 0.7,
    gradientTransform: "matrix(.76 0 0 .76 -.1 -1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ce",
    cx: 0.2,
    cy: -0.1,
    r: 0.2,
    gradientTransform: "matrix(3 0 0 2.96 404.7 143.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cf",
    cx: 0.5,
    cy: 0.2,
    r: 0.4,
    gradientTransform: "matrix(1.42 0 0 1.32 8.1 11.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cg",
    cx: 0.5,
    cy: -3.2,
    r: 1.1,
    gradientTransform: "matrix(.44 0 0 .49 -57.4 -252.3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ch",
    cx: 0.5,
    cy: 0.4,
    r: 0.7,
    gradientTransform: "matrix(.75 0 0 .75 -.3 -1.1)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ci",
    cx: 1.1,
    cy: 2.2,
    r: 0.1,
    gradientTransform: "matrix(4 0 0 4.41 4699.5 673.2)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cj",
    cx: 0.5,
    cy: 0.8,
    r: 0.5,
    gradientTransform: "matrix(.92 0 0 .88 -1.9 -6.4)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ck",
    cx: 0.5,
    cy: 0.6,
    r: 0.7,
    gradientTransform: "matrix(.75 0 0 .75 -.7 -1.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cl",
    cx: 0.5,
    cy: 1.5,
    r: 0.3,
    gradientTransform: "matrix(1.63 0 0 1.83 104.2 100)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cm",
    cx: 0.5,
    cy: 0.1,
    r: 0.5,
    gradientTransform: "matrix(1.04 0 0 1.1 2 6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cn",
    cx: 0.5,
    cy: 0.4,
    r: 0.7,
    gradientTransform: "matrix(.75 0 0 .75 -1.5 -3)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "co",
    cx: 0.4,
    cy: 0.3,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 .96 0 -5.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cp",
    cx: 0.5,
    cy: 0.2,
    r: 0.6,
    gradientTransform: "matrix(.84 0 0 .82 -7.5 -14.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cq",
    cx: 0.5,
    cy: 2,
    r: 0.4,
    gradientTransform: "matrix(1.13 0 0 1.2 27.8 45.8)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cr",
    cx: 0.5,
    cy: 1.7,
    r: 0.3,
    gradientTransform: "matrix(1.83 0 0 1.37 257 67.6)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cs",
    cx: 0.7,
    cy: 2.9,
    r: 0.3,
    gradientTransform: "matrix(1.4 0 0 1.63 176.4 193.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "ct",
    cx: 0.5,
    cy: 2,
    r: 0.6,
    gradientTransform: "matrix(.9 0 0 .86 -16.5 -32.9)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cu",
    cx: 0.5,
    cy: 0.1,
    r: 0.6,
    gradientTransform: "matrix(.88 0 0 .91 -27.8 -27.5)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cv",
    cx: 0.6,
    cy: -0.7,
    r: 0.3,
    gradientTransform: "matrix(1.6 0 0 1.65 264 175)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cw",
    cx: 0.5,
    cy: 1.4,
    r: 0.7,
    gradientTransform: "matrix(.7 0 0 .7 -49.8 -96.7)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cx",
    cx: 0.4,
    cy: 3.3,
    r: 0.6,
    gradientTransform: "matrix(.75 0 0 .88 -57.4 -47)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "cy",
    cx: 0.5,
    cy: 5.2,
    r: 1.3,
    gradientTransform: "matrix(.38 0 0 .4 -139 -566.7)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.1,
    x2: 1,
    y1: 0.8,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17dbb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f59da"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M245.6 2.8h24.3V21h-24.3z",
    "data-name": "Rectangle 17865"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-map",
    "data-name": "Group 47016"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(0px 20px 33px rgba(0, 0, 0, 0.5))"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M432 276h484a30 30 0 0 1 30 30v355a30 30 0 0 1-30 30H432a30 30 0 0 1-30-30V306a30 30 0 0 1 30-30Z",
    "data-name": "Path 46659"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eceff1",
    "data-name": "Group 47037",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m945.2 446.3.3 1.5v1.1l-.5-.6-.3-.8.8-1.4Z",
    "data-name": "Path 47091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 485.5v.1a1.7 1.7 0 0 1 .2.5v-.8Z",
    "data-name": "Path 47092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.8 421.1a4 4 0 0 1 1 1.8 2.7 2.7 0 0 1-.9 2.1 8.9 8.9 0 0 1-2.8.7c-.9.1-.5 2.2-1.4 1.9-1-.3-1 .4-.6.9.4.6 1.2 3.4 2 3.6a5.7 5.7 0 0 1 2.4 2c0 .4 0 1.9.4 2.4 1-.6 2.5-1.6 3.1-1.4.7.2 2.8 3.3 2.8 3.3h1.3l.1-11.5 6-1.9c3.4 1.8 7.5 6.2 7.5 6.2l6.7-.4 1.6 2.3.7-.1.8 2.3.7 1v2.4l2.7-.1.6.6v-47.7l-6.2 1-.2 1.3-3.4.6-3 1.2-1.4-.1-1.4-.3-.9 1.5 1.4.6-.5.8 2.2 1.1-2.6-.2a5.8 5.8 0 0 0-.2 1.9c.1.6 0 .8-1 1.4a1 1 0 0 0-.6 1.4 5.3 5.3 0 0 1 2.1 1.1 1.4 1.4 0 0 1 .3.4c.6.9 1.1 2.6-.2 2.6a7.4 7.4 0 0 1-2.9-.8l-.8 1.2a11.8 11.8 0 0 1-2.5-1.9c-.2-.4-1.5-.2-1.5-.2l-.6 1-1.2-1a4.9 4.9 0 0 0-1.8 1.1l-.9 1.2-2.5-2-.3 1.8-1.2-2.1-1.4-1.4h-1.8l-.5-.9a20 20 0 0 1-1.9 1.1c-.5.2-.5-.8-.5-.8l-1.2-.1-3 2.2-.2 1.1-1.8.5a17 17 0 0 1 .4 2.3c0 .2 0 .4-.2.4a11.6 11.6 0 0 1-2.4-2l-1.5 1.8v.1l.1 2.6-1 2.4 1.3.2v2h2l2.2 3.2-1.3.3 2.5 1.6a8 8 0 0 1 7.3-1.6Z",
    "data-name": "Path 47093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.3 465.2v1l-1.8.1-1 .6-.4 2.2-2 1.6a45.2 45.2 0 0 1-5.4.6 13.7 13.7 0 0 1-4.4-1.2l2.4 3.6h1.7v3h1.2s.4 1.3-.2 1.6c-.5.2-1.6.2-2.3.5a1 1 0 0 0-.5.4 27.6 27.6 0 0 0-.8 2.7l4-.2c4-.3 8-2.1 10.4 3.7l.3-.1v-20.5l-1.2.4Z",
    "data-name": "Path 47094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944 443.7 1.1 1.2.4 1.2v-2.8h-1Z",
    "data-name": "Path 47095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945 450.2a1 1 0 0 0 .1.4c0 .1.1.2.3.2h.2v-2l-.7 1.4Z",
    "data-name": "Path 47096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.8 471.3a31.9 31.9 0 0 0 5.3-.6l2.1-1.6.3-2.2 1.1-.6 1.7-.1.1-1 1.2-.4v-14h-.2l-.3-.2a1 1 0 0 1 0-.4h-.2l-2.6-.6-2.3-.5v1.1h-2v2.1l-3.4 1.5v1.5l-1.9.3-.4-.6-2.2-.7v.8l-1 1.6-.2 2.9.4 6 2 .3v1.8l-1.9 2.3.1.1a12 12 0 0 0 4.3 1.2Z",
    "data-name": "Path 47097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m942.2 438.7.1-2.4-.7-1-.8-2.3-.7.1-1.6-2.3-6.7.4s-4.2-4.5-7.5-6.2l-6 1.9v11.5h2.2l.4-2.2s.7.2 1-.2a15.5 15.5 0 0 1 1.5-1.4s4.4 3.7 5 3.7c.7.1 3-.8 3.5.8.6 1.4.4 2.3 1.6 3.3l.6.4 6.7 4.4.6.3a1.6 1.6 0 0 1 1 1.6v.5l2.6.6.7-1.3v-2.8l-.5-1.2-1-1.2.3-.4h1.1v-4l-.6-.6Z",
    "data-name": "Path 47098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m928 451.5 2 .2v2.6l2.2.7.4.6 1.8-.3.1-1.5 3.3-1.5.1-2.1h2v-1.1l2.3.5v-.5a2 2 0 0 0-1-1.6l-.6-.3c-.8-.4-4.9-3.2-6.7-4.4l-.6-.4c-1.2-1-1-1.9-1.6-3.3-.7-1.6-2.9-.7-3.5-.8-.7-.1-5-3.7-5-3.7a15.5 15.5 0 0 0-1.5 1.4c-.3.4-1 .2-1 .2l-.4 2.2h-3.6s-2-3.1-2.8-3.3c-.5-.2-2.2.8-3 1.4.2.2.5.2 1-.1 1.7-1 2.5.9 3.1 2.2s-.4 1.6-2.6 1.2c-2.3-.3-1.5 1.4-1 2.1a18.1 18.1 0 0 1 2.2 4.4 8 8 0 0 1 .4 3.4h.4l.8-.1 1.8-1.8h2l.8-.8 1.1-.1.4.9 2.3.4 1.4.6 1 .2.2 1.3h1l.8 1.2Z",
    "data-name": "Path 47099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.7 476.7h-1.2v-3h-1.7l-2.4-3.6v-.1l1.8-2.3v-1.8l-2-.3-.4-6.1.2-2.9 1-1.6v-3.4l-2-.2-1-1.2h-.9l-.2-1.3-1-.2-1.4-.6-2.3-.4-.4-.9-1 .1-1 .8H917l-1.8 1.8-.8.1h-.4a2.2 2.2 0 0 1-1 1.8c-1.4.7-5.8-.6-8.4-2.2-1.4-.9-1.8-1.6-1.8-2.6a6.1 6.1 0 0 1-1.2-.5l-.9-1a.8.8 0 0 1 .1-.3c.1-.6.2-1.7-.3-1.7-.6 0-2 2-3.6 2.2h-1c-1-.5-2.2-1.5-3-1.8a.8.8 0 0 0-.9 0c-.8.5 0 3.5 0 3.5l.5 1.4.5 1.9.7 2.3.4.8 2.1.4-.4 1.2-.7 1.1v2.2l-1 .3 1.4 1 .7 2.1s2.6.6 3.1 2a33.8 33.8 0 0 1 .8 3.4l1.7 2.9 1.3-.6c3.4-1.2 4.1 3.1 4.2 4.2s5.2 3.6 5.6 4.1c.4.4 5.3.2 7.2 1.6a1.3 1.3 0 0 1 .6.7c.8 1.7 6 2 10.4 1.9a27.6 27.6 0 0 1 .8-2.7 1 1 0 0 1 .5-.4c.7-.3 1.8-.2 2.3-.5s.1-1.7.1-1.6Z",
    "data-name": "Path 47100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.6 482.6v1.3l.8.9h-1.3l-.7 2.3.1 1.6a4.3 4.3 0 0 1 .7.6 3 3 0 0 1 .5.7c.3.9-2.7 5.1-2.7 5.1l-5.5 1.6-.4.1.1.1 3.3 6.6a57.5 57.5 0 0 0 12.4-11.2c4.1-4.9 1.6-5.9-.8-6.3a5.6 5.6 0 0 1-4.4-3.7 6.1 6.1 0 0 0-.5-1.2v1.7l-1.6-.2Z",
    "data-name": "Path 47101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.2 487.9a9.1 9.1 0 0 1 1.3.8v-1.6l.6-2.3h1.3l-.9-.9.1-1.3 1.4.2.1-1.7c-.3-.6-.6-.7-1-.5-.6.3-3.4 3.7-7 3.9a4.2 4.2 0 0 1-2.4-.5l-.2.3 2 3 3.5.4 1.2.2Z",
    "data-name": "Path 47102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.1 464.7c-1.9.3-2.9.7-2.6 1.2l.2.2a7.4 7.4 0 0 1 1.7 1.8c.3.6.2 1.2-.8 1.6-2.3.9-2.6 2-3.3 2-.6 0-2.3-.1-2.8-.7l-.3.6.1 3.3a3.8 3.8 0 0 0 1-.1c2.3-.2 5.5 9.2 9.8 16.7 2.8 4.8 5.3 8.2 7 11.6l1.5-.5.1-.6.2-1.7 8 .7.7.7 3.6-3.4 7-1.4.3-.1 5.5-1.6s3.1-4.2 2.7-5.1a1.8 1.8 0 0 0-.5-.7l-.7-.6a5.7 5.7 0 0 0-1.3-.8l-1-.1-3.7-.4-1.9-3 .2-.3c-2.2-1.2-3.6-4.1-5.2-6.8l-2.4-3.8h-1.5l-.4-.5-.8-.9-1.6-.1-3.5-.3s-7.3-5.7-9.3-6.5a8 8 0 0 0-3.4-.7 23 23 0 0 0-2.6.3Z",
    "data-name": "Path 47103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.1 498.1-3.6 3.4-.7-.7-8-.7-.2 1.7v.6l-1.7.5a21.4 21.4 0 0 1 1.8 6.1 2.6 2.6 0 0 0 1.4 2.2c3.6 1.6 12.6-3.5 17.3-5.6a31.1 31.1 0 0 0 4-2.2l-3.3-6.6v-.1l-7 1.4Z",
    "data-name": "Path 47104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.4 516.5s1.4 2.6 2.2 2.9l2.3 1.1a13 13 0 0 0 3.5 1.4l4 .3-6.6 6.9-4 .4a12.7 12.7 0 0 0-3.4 2.4l-2 1.9-.2 8.7 1.5 1.5a140.4 140.4 0 0 1 13.3-12.3c3.4-2.7 8.1-13 8.6-16.7.6-3.6-3.2-.8-7.9.8-4.2 1.4-7.6 1.2-9.8-1.9l-1 1.6-.5 1Z",
    "data-name": "Path 47105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.3 572.5a9.2 9.2 0 0 0-1.7-3.6v-.1a.7.7 0 0 0-1 .1c-1 1.5-1.6 4.3-3.9 5.8-2.6 1.8-6 1.3-6.6 4.6-.4 3.3 0 4.9-.4 7.5s-2 2.4-2 5 .2 6.1 2 7.5 6.8 1.3 8.4-4.6c1.5-5.9 4.4-12.5 4.4-14.9s0-3.7.6-3.7 1-.7.2-3.6Z",
    "data-name": "Path 47106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.8 446.7a18.8 18.8 0 0 1 .6-3.2 8.5 8.5 0 0 0-1.6-6.6l-1.6 1.6-1.4-.4-1-1.2-1.3-.4v.3l.1 1 .6.7v.2l-.3.4-.6-.3-.8-.4-1.5-.3-.4.8 1.4.7-.5.6.6.7.2.3.2 1.2v.1l.8.5.5.3.2 2.5c1.4-.3 3-2.2 3.6-2.2.5 0 .4 1.1.3 1.7a.4.4 0 0 1 0 .3l.8 1c.3-.3.7-.1 1.1.1Z",
    "data-name": "Path 47107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900 467.1-.9-3.4c-.4-1.4-3-2-3-2l-.8-2.1-1.4-1 1-.3v-2.2l1-1.1.3-1.2-2-.4-.5-.8-.7-2.3a11.6 11.6 0 0 1-3.2-.8 3 3 0 0 0-.9-.2l-2.8 2.3c-.9.7-1 .8-1 3.3s-1.6 3.2-5.6 5.6l1 3.9a8 8 0 0 1 3.4.7 86 86 0 0 1 9.3 6.5l3.5.3 1.6-2.6c.3-.4 2 .3 3.1.8l.2-.1-1.7-2.9Z",
    "data-name": "Path 47108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m899.2 472.9.4.5h1.5c-.7-1.3-.9-2.5.3-3.3-1-.5-2.8-1.2-3-.8l-1.7 2.6 1.6.1 1 .9Z",
    "data-name": "Path 47109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886.4 513.4 1.1-1.1h.2l-1.6-2.2-3.2-2.8h-4.2l-1.2-.9-1 1.5-2.2-.2v1.7l-.4 2.1h-1.5l-.4.5-1 1.3v.1l-.2 2.4-1.5.2-.2 1.3v3.4l-2.7.2-.3 1.8 3 .7.6 1.4 1.2.4v2.7l2 .2.1 1.7 2.7.2 1.5 1.8.3.4h3.4l3-1.7 1.2 1a6.3 6.3 0 0 0 1.1.1 15.5 15.5 0 0 1 3.3-2.4l4.1-.4 6.6-6.9-4-.3a17.6 17.6 0 0 1-3.5-1.4l-2.3-1.1c-.8-.2-2.2-2.9-2.2-2.9l.6-1-2.5-.1.1-1.7Z",
    "data-name": "Path 47110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897 445.4-.3-2.5-.5-.3-.8-.4v-.1l-.2-1.2-.2-.3-.6-.7.5-.6-1.4-.7-2 .1-1 .3v2.5l1.3.4 1.4.5 1 .4.4.5h.8l.1.4.1.3.4.2v1h.3c.2.3.4.3.6.2Z",
    "data-name": "Path 47111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m884.5 433.1.4.2a3 3 0 0 1 .6 4.3h3.2l1.7 1.3 1-.3 2-.1.4-.8 1.5.3.8.4.6.3.2-.4.1-.2-.7-.7v-1.3l-.6-.2v-.1l-1-1.8-.5-.4-1.5.2-1.3.4-.7-.6-2.6-1.7-1.9.1-3-1-.5.2-.3.1a8.4 8.4 0 0 0 2.1 1.8Z",
    "data-name": "Path 47112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m896 444.3-.4-.2v-.3l-.2-.4h-.8l-.5-.5-.9-.4-.3 1c1 .3 2 1.3 3.1 1.8v-1Z",
    "data-name": "Path 47113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.2 453h.3l.7-.1-.4-2.1 1.8.8a5 5 0 0 1 3.8-.2c1 .4 2.2-.7 3.6-.9 1.2-.2 3.5-1.1 5-1.2a3 3 0 0 1 1 .2 11.6 11.6 0 0 0 3.1.8l-.5-1.9-.5-1.4s-.8-3 0-3.5a.7.7 0 0 1 .5-.1.6.6 0 0 1 .4.1l.3-1-1.4-.5-1.4-.4.1-2.5-1.8-1.3h-3.2l-.5.7c-.6.6-6.5.9-9.5-.1-2.9-1-6.2-2-8-2s-2.7 1.2-4 2.2-4.2.1-5.6-.1a9.1 9.1 0 0 1-2-1.8.3.3 0 0 0-.2-.2H854l-.9-.3-1 .5-.5.2.5 1.3-.5.9-1 1.1c1.5 1.1.7 4.3.7 5.2 0 1 1.3 1.5 2.1 3.7 1 2.6 5.4 4.2 7.3 3.5 2-.8 2.6-.7 4.5.4s2.2.6 3.5-.3a4 4 0 0 1 4.8.1 2.2 2.2 0 0 1 .3.5l.4-.3Z",
    "data-name": "Path 47114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.8 512.3h-.2l-1 1.1v1.9l2.4.1 1-1.6a7.5 7.5 0 0 1-.7-1.2c0-.1 0-.3-.2-.4l-1.3.1Z",
    "data-name": "Path 47115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875.3 501.1-.2 2.6-1 2.1v1.9l2.2.2 1-1.5 1.2.9h4.2l3.2 2.8a18.3 18.3 0 0 1 1.6 2.2l1.2-.1-.6-1.1c-2.2-3.2-5.3-4.7-7-7.2a26.7 26.7 0 0 1-2.5-4.3l-2 1.5h-1.3Z",
    "data-name": "Path 47116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873 462.3a.7.7 0 0 0 .6.4c1.8.5 2 .2 6-2.2 4-2.4 5.5-3.1 5.5-5.6s.1-2.6 1-3.3l2.8-2.3c-1.5 0-3.9 1-5 1.2-1.4.2-2.7 1.3-3.6.9a5 5 0 0 0-3.8.2l-1.8-.8.4 2.1-.7.1h-.3l-.4.1a10.7 10.7 0 0 1-.7 3.9 1.4 1.4 0 0 1 1.1.1 2 2 0 0 1 0 2.4 3.6 3.6 0 0 0-1.2 1.6 4.1 4.1 0 0 0 .1 1.2Z",
    "data-name": "Path 47117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 531.9a7.5 7.5 0 0 0-1-.1l-1.3-1-3 1.7h-3.4l-.3-.4-1.5-1.8-2.7-.2-.7-.1-.4-.8-1.2-.1-1.6 1.6 2.1 5.4-2.6 4.1v2.4l8.5 4.6v1.1l4 2.8v-.4c.1-1.5 2-4.1 4.6-6.9l-1.5-1.5.1-8.7a14 14 0 0 1 2-1.7Z",
    "data-name": "Path 47118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.7 413.7-.7 1.7 1.4 1.8 1.3-.7.5.4h2.4a1.5 1.5 0 0 0 .6.7l.4.1a3.7 3.7 0 0 0 1.1-.5 4.3 4.3 0 0 0 2-.4 2 2 0 0 0 .8-.9.8.8 0 0 0 .2-.4l2-.1a4 4 0 0 0 1.4 1.2 7.6 7.6 0 0 0 2.1.3l-.2 2.2.8-.2.1 1.6s.8.1.8.7c0 .4 0 1-.3 1.1a.4.4 0 0 1-.5 0 20 20 0 0 0-1.4-.3v1.7l-1.5.9.1.7a1 1 0 0 0 1 .6c.5 0 1.1-.6 1.4-.6.2 0 .6.4 1 .7l1-1.6a7.2 7.2 0 0 1 3.4-2.9c1.6-.5 1 1.2 1.1 1.6.2.3 1.6.2 2.5.3l1-.4 2.1 1a2 2 0 0 1 0-1.1c.3-.8 2.5-1.3 4-1.8a22.9 22.9 0 0 1 3.7-1.2 5.8 5.8 0 0 1 .8-2.2c.5-.5 2-.4 2.7-.4l.4-.1c.3-.2.2-.7.2-1 0-.5-1-1.1-1-1.1l.1-.2 1-.9-1.3-.6 1.2-.2.4-1.3c0-.2-.8-.3-1.2-.3a4.2 4.2 0 0 1-1.4-.6l-1.5-1.2-.9.5c-.4.3-1.4-1.8-1.4-1.8a8.9 8.9 0 0 1-1.7.8c-.5 0-1.5-1.1-1.5-1.1l-.8.8-.5-1.2v-1l-.4.1v-1.3l-2.3.2-.2-1.7h1l-1.3-1.6-.6-.9-1 .5-.8.4v-.4l-1.3-.2v1l-1.5.1-1.8.1-.7.9v1.8l-1-1-1.2.5-.8-.1-.3-.9-.9 1.1-1.2-1.3-1 1.1s-1.2-1.6-2-1.6l-4.8-.3a11.4 11.4 0 0 0-2.5 1.8l.7.5-.2.6.6.2v2.4l-1 .1-.7.9-1.5 2.1.4 1.3a.3.3 0 0 1-.2.1v.1a3.3 3.3 0 0 0-.7.3Z",
    "data-name": "Path 47119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.1 548.4v-1.1l-8.5-4.6h-7.8l.5 1.1.5 1.3-.8.7h-.3v1.1h1l-.2 1-1.8 2.3-1.5-.1v.1l.4 4.5a5.3 5.3 0 0 1 1.4 1.2l1.6 3.3.5.9 4.6 1.8.3.6 2-.2.7.9a1.8 1.8 0 0 1 .4.9 16.4 16.4 0 0 0 .2 2.2l-.5 1.1c.7-.2 3-1.3 3.6-.9a9.6 9.6 0 0 0 3.3.6l1.1-1 1.1.1 4-1.8c-1-3.9-2-8.4-1.9-13.1l-3.9-2.9Z",
    "data-name": "Path 47120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.6 460.5c-3.9 2.4-4 2.7-5.9 2.2a1.5 1.5 0 0 1-.6-.4 1 1 0 0 1 0-1.1l-1.4-.1-.5 1.3c0 .3 0 .5-.2.8l1 .4.3.1-.2 3.9-1.6 3.2c.5.7 2.3.7 3 .7.6 0 1-1.1 3.2-2 1-.4 1.1-1 .8-1.6a7.5 7.5 0 0 0-1.7-1.8l-.2-.2c-.2-.5.7-.9 2.6-1.2a19.4 19.4 0 0 1 2.4-.2l-1-4Z",
    "data-name": "Path 47121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.4 494.3H846v1.2l.2 9.2-1-.1-1-.1-.5 1.7-1 1.3.1.8-1 .9.6.7-1.2 1.6 1.8.1v2.5l1.1.4-.3 1.1.1.2 1.5 2.6 2.5-.1 1-1.3 1.5-.3 1.1 1.8 3.6.4 1.4.7 1.5-1.1 1.8-1.1 3.1 1 2.5-2.6V514l-.9-.9 2.2-.4.3-.5.6.2-.4 3 1.2 1.3 1 .6.1-1.3 1.5-.2.1-2.4v-.1l1-1.3.4-.5h1.5l.4-2.1v-3.6l1-2.1.2-2.6h1.5a13 13 0 0 0 2-1.5 34.6 34.6 0 0 1-2.6-7 23 23 0 0 0-.9-2.8l-26.7-.2-.5 4.7Z",
    "data-name": "Path 47122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.5 470.8v-.4a46.4 46.4 0 0 0-1-4.8 2.7 2.7 0 0 1-2.7.2c-3-1-6.3.3-7.9 1-1.2.5-4.6-.5-9.3-2.4l-1.4 1.9.1 1.5-.6 1.1.5 1.2.4.4v18.8l26.7.2a85.8 85.8 0 0 0-5.4-9.9c-1.8-2.9-2.7-3.8-4.2-7.2-1.4-3.4 1.3-.3 2 .9.4 1 1.1 1.3 2.7 1.2v-3.3l.1-.4Z",
    "data-name": "Path 47123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.1 459.5a2 2 0 0 0 .1-2.4 1.4 1.4 0 0 0-1-.1l-1.6 4 1.4.1a4.2 4.2 0 0 1 1.1-1.6Z",
    "data-name": "Path 47124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.8 278c0 1.6-8.2 21.1-10.9 24-2.6 2.9.4 4.8 2 5.1s1.5 3.5 2.2 4.8c.6 1.1 5.1 1.1 7.6.6l.3-.1a.7.7 0 0 0 .2-1.1l-3.5-5.6c-1.2-2.3-.4-4 3.2-14.5a31.3 31.3 0 0 1 7.5-12.1 30.7 30.7 0 0 0-8-2.6 12.6 12.6 0 0 0-.6 1.5Z",
    "data-name": "Path 47125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.5 304.9c-1.2 3-2.5 5.7-3 7.2-.9 1.9.7 5.7 3.1 9.2v-16.4Z",
    "data-name": "Path 47126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.2 375.4a.4.4 0 0 0 0 .3 13.6 13.6 0 0 0 .6 3.5l-.8 2.2v.1l.7.7-.3 2.1 1.2-.3.2 3.1 1.4.8 1.4-.2.1 1.2.7-.4 1.2-.7.6.8.8.3v.8l-.6.7.7.7-.4 1.1 1 .5.4 2 1.1.1v1.8l1.4-.4v.7l.8.7-1.2 1.4-2-.3v2.4h.6v1.7h1.5v-1l1.2.2.1.4.7-.4 1.1-.5.6.9 1.2 1.6H869l.2 1.7 2.3-.2v1.3l.4-.1v1l.5 1.2.8-.8s1 1.1 1.5 1.1a5.3 5.3 0 0 0 1.7-.8s1 2.1 1.4 1.8a4 4 0 0 1 1-.5l1.4 1.2 1.4.6c.4 0 1.3.1 1.2.3a10.4 10.4 0 0 1-.4 1.3l-1.2.2 1.3.6-1 .9-.2.2s1.2.6 1.1 1.1a2 2 0 0 1-.2 1.1l-.4.1c-.8 0-2.2-.1-2.7.4a5.8 5.8 0 0 0-.8 2.2 11 11 0 0 1 1.8-.2c1.8 0 0 .9-.4 1.1a16.4 16.4 0 0 0-2.6 3.7c-1 1.7-.3 3.2.6 3.4.7.2 2.5 2 4.7 3.7l.3-.1.5-.2 3 1 2-.1 2.5 1.6.6.6 1.3-.4 1.5-.2.5.4 1 1.8v.1l.6.2 1.3.4 1 1.2 1.4.4 1.6-1.6-.6-.7c-1.3-1.2-1.5-3.3-1.5-4.9 0-1.6-1-2.9-1-3.8s3.2-3.4 5-4.7l-2.6-1.6 1.5-.2-2.2-3.2h-2v-2l-1.3-.2 1-2.4v-2.7l1.4-1.8a11.6 11.6 0 0 0 2.4 2c.1 0 .2-.1.2-.4a14.4 14.4 0 0 0-.4-2.3l1.8-.6.1-1.1 3.1-2.2 1.2.1s0 1 .5.8l2-1.1.4.9h1.8l1.4 1.4 1.2 2.1.3-1.8 2.5 2a9.4 9.4 0 0 1 1-1.2 4.2 4.2 0 0 1 1.7-1.1l1.2 1 .6-1s1.3-.2 1.5.2a23.5 23.5 0 0 0 2.5 1.9l.8-1.2a7.4 7.4 0 0 0 3 .8c1.1 0 .7-1.7.1-2.6l-.3-.3a5.3 5.3 0 0 0-2-1.1c-.2-.1-.6-.8.4-1.4 1-.7 1.2-.9 1.1-1.4a6.2 6.2 0 0 1 .2-1.9l2.6.2-2-1.1.4-.8-1.4-.6 1-1.5 1.3.3 1.4.1 3-1.2 3.4-.6.2-1.3 6.2-1v-64.6c-.9-.1-2.9-2.2-5.5-5.1s-6.7-3.4-9.8-4.7-4.5.1-3 .9c1.4.7 2.7 4.4.2 5.4a29.1 29.1 0 0 1-7.8 1.5c-2.6.3-3 1.3-6.6-.4s-8.8 2.9-12.5 7.3-2.8 4.1-4.5 3.2a.9.9 0 0 1-.6-.6l-3.5.6a11 11 0 0 1 .6 2.6c0 1.6-1.3 1.3-3.5.2s-5.5 3.7-6.8 4.8 0 1.7 1.2 3.7-4 .9-6-.4-2.7.2-1.9 1.7c1 1.4 2.2 2.2 2.5 3.3s-1 1.1-2.3 1-3.7-2.2-4.2-3.6a58.2 58.2 0 0 1-.8-7.3c0-1.6-3-2.7-4.4-4.8s-.8-1.5 0-1.2 3.4 1.8 8.5 4.1c5 2.3 6.4 1.3 8.7-.9s1.6-2.7 1.5-5.7-5.4-4.7-8.6-7.8-5.4-3.5-8.2-3.7a17.7 17.7 0 0 1-6.3-2.5v1.1h-1l-.9-.6v1.4l-1.6.8-.5 1.7-1 .5v1.1l-.3 3.4a8.5 8.5 0 0 1 2.5 1.7c1 1 .1 2.6 0 3.1s-1.5 2.3-1.5 2.6 2.5 7 2.5 7l-1 .2-.2 2.6.5.4-.6.8.3.8h1v2.6l1 1.1-1.2 1.6s4.3 2.8 3.3 4.6c-.8 1.5-6.2 8.3-8.4 11.1a2.4 2.4 0 0 1 2.6 1c.3.5 2.2.7 2.7 1.2s-1 .5-2 .5c-.8 0-1.4 1.3-2.6 1.8l.4.9a18 18 0 0 0-1.8 1.9Z",
    "data-name": "Path 47127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.4 334.4c-.7-1.2.4-3.2 2-4.1 2-1-2.2-4.2-3-4.8-1-.6-2.6 2.3-3 5.1a9.4 9.4 0 0 0 .5 4.4l3.5-.6Z",
    "data-name": "Path 47128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.4 423-.9.4.7.1c.7.3-2 1-2 1.2-.3.2 1.7 1.2 2 2.8.4 1.6 1.2.7 2.3.2a8 8 0 0 1 3.5-1.1c1.1.1.4-.9.3-1.2 0-.4-1.8-.3-2.7-.4a1.2 1.2 0 0 1-.9-1.1l-2.3-.9Z",
    "data-name": "Path 47129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m867.1 562.4 1 1.5-1 1.1v2.2l.8 1.1-1 .3v1.4l-1.3 1.1 1 1.1 1.3.8 1.6.1.2 1.1s-.9 2-.5 2.2a36.2 36.2 0 0 1 2.2 3.2l.3-2.4 1.2-.2s1-2.9.4-3.9v-.2c-.8-.7-2.6-1.3-3-1.8a.1.1 0 0 0-.2-.1v-.1c-.2-.6-1-3.5-.3-3.7l.5-1.1a16.4 16.4 0 0 1-.2-2.2 2.3 2.3 0 0 0-.4-.9 4 4 0 0 0-.8-.9l-1.8.3Z",
    "data-name": "Path 47130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847.8 518.3-2.5.1v2.4l2.7.7 1.1 1.8 2.5 2v1.5l2 .5v1.4l2.6 2.1.7-.6 1.3.4.6-.7 2.7 2.5 2.2-.7 1 .8v.1l1.1-.8 2.5-.2 1-.8 1.5-1.7 1.3.1.3.8h.7v-1.7l-2-.2v-2.7l-1.4-.4-.7-1.4-2.9-.8.3-1.8 2.7-.2v-3.4l-.8-.6-1.3-1.3.4-3-.6-.2-.3.5-2.2.4 1 .8v1.8l-2.6 2.5-3-1-1.9 1.1-1.5 1.1-1.4-.7-3.6-.4-1-1.7-1.5.3Z",
    "data-name": "Path 47131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872 467.7.2-3.9-.3-.1-1-.4a4.9 4.9 0 0 1-1.6 2.4 87 87 0 0 1 1 4.8v.2l.1.2 1.6-3.2Z",
    "data-name": "Path 47132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.6 542.7v-2.4l2.7-4.1-2-5.4-1 .8-2.5.2-1.2.8v-.1l-.9-.8-2.2.7v2.9l1.1.2-3 2.8v1.2l-.5.4-.2 3.9.7-.6 1.2-.5h7.8Z",
    "data-name": "Path 47133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.2 571.1c.5.5 2.3 1.1 3 1.8a.3.3 0 0 1 .1.2c.5 1-.4 3.9-.4 3.9l-1.2.2-.3 2.4a36.2 36.2 0 0 0-2.2-3.2c-.3-.2.5-2.2.5-2.2l-.2-1.1-1.6-.1-1.4-.8-5.9 2.2.1 1.2a3 3 0 0 0 .4 1 43.4 43.4 0 0 1 4.8 1.4c1.4.6.4 2.1.7 3.1a4.6 4.6 0 0 1-.4 2.6l.4 2.4-1.5 1.5.2 2.1-3 2.5a1.2 1.2 0 0 1 .4.1l1.2 3.5.1 4.8.4 2.4 2.3.2c0-2.2-1.3-3.2 2.7-4.6 3.8-1.3 2.8-6.5 1.1-10.8a2.8 2.8 0 0 1 0-.9c.5-3.2 10.5-6.9 12.8-11.6 1.2-2.6.3-6.4-.8-11l-3.5 1.8-1-.1-1.2 1a19 19 0 0 1-3.3-.6c-.8-.4-3 .6-3.6.9-.6.2.1 3.2.2 3.7l.1.1Z",
    "data-name": "Path 47134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.6 457a2.8 2.8 0 0 0 1.3.3 1.7 1.7 0 0 0 .7-.1l.3-.2c.6-.4 1.2-.9 2-1.3a1.2 1.2 0 0 0 .4-.5.7.7 0 0 0 .1-.6.8.8 0 0 0-.8.1 2.5 2.5 0 0 1-.7.4 1.7 1.7 0 0 1-.7.1l-1.7.1a1.2 1.2 0 0 0-1.2.5 1 1 0 0 0 .3 1.2Z",
    "data-name": "Path 47135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.1 560.1-.5-.9-4 .4-2 1.9 1 1.3-.4 4.8 1.4.6 1.4-.2.4 1.1-.5 1.3h-1.2l-1.5-1.3-2-.8-.4-.5-.5-.9-.5.7-1.8.1h-.3l-1.4-.8-.3-1.1h-1.8l-1-.7-.2 4.7-4.5.2.4 8 2.6 2.6a4.1 4.1 0 0 1 1-.1 17.2 17.2 0 0 1 3.2.2l2.4.3c.1 0 .1.1 0 .2 0 .1 0 .2-.2.3h2a13.4 13.4 0 0 1 1-1.4 3.5 3.5 0 0 1 1-.8 4.3 4.3 0 0 1 2.1-.9v-1.8l3.4-1v-1.2l5.8-2.2-.9-1.1 1.2-1.1v-1.4l1.1-.3-.9-1.1V565l1-1.1-.9-1.5-.3-.6-4.4-1.7Z",
    "data-name": "Path 47136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m864.6 603.1-.6 1.6-2.3-1.2 1-3.1 1.5.3v-4.8l-1.3-3.5a1.8 1.8 0 0 1-.5-.1 25.6 25.6 0 0 0-2.7-.5 3 3 0 0 0-1 .2 12.2 12.2 0 0 1-2.6.6c-1.5.1-2.8 2.6-2.8 3.1a2.4 2.4 0 0 1-2.3 1.9c-1.5 0-.7.6-1 1.9s-3.2 1-5.9-.6l-.6 2.2c0 .4-2.3 2.1-2.3 2.1h-2.4l.3-2.6-1.8-2.3v5.9c0 1.8 0 2.3-.9 3.7a2.6 2.6 0 0 1-2.6.8 57 57 0 0 1-1.7-.3c-1.3-.3-1.2-2-1.2-2l-2 1.8c2 3.7 4.5 8.8 4.5 12.6.1 5.2 8.5 2.9 16 2s13.1-11.6 15.5-14.6a6.4 6.4 0 0 0 2-4.5l-2.3-.6Zm-6.7 8.2c-.7.6-2.9 2-3.6 1.4a2.8 2.8 0 0 1-.8-1.1.6.6 0 0 1 0-.4l.4-1.6 1.4-1.3.2-.4.1-.1a.3.3 0 0 0 .2-.1h.1l.3-.1h.6a.1.1 0 0 1 .1.1l.2.2a3.8 3.8 0 0 1 1.1 1.9 1.8 1.8 0 0 1-.3 1.5Z",
    "data-name": "Path 47137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.6 575.7-3.5 1 .1 1.8a4.3 4.3 0 0 0-2.2.9 3 3 0 0 0-.8.8 7.6 7.6 0 0 0-1 1.4h-2a1.9 1.9 0 0 1-.3.4l-.4 1.5 1.1 2 1.2.7h.6l.5 1.6 1-.3v2l.8.6 1.2.1 1.2.5.6 1.3 1-.2a12.8 12.8 0 0 1 2.7.5l3.1-2.5-.2-2.1 1.5-1.5-.4-2.4a4.6 4.6 0 0 0 .4-2.6c-.3-1 .6-2.5-.7-3.1a43.4 43.4 0 0 0-4.8-1.4 1.3 1.3 0 0 1-.7-1Z",
    "data-name": "Path 47138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m845.3 402.7.1 2.3a14.4 14.4 0 0 1 2.5-1.8c.5-.1 3.7.3 4.7.3s2.1 1.6 2.1 1.6l1-1.1 1.2 1.3 1-1.1.2.9.8.1 1.1-.5 1 1 .1-1.8.7-.9 1.8-.1v-1.8h-.6v-2.4l2 .3 1.2-1.4-.8-.7v-.7l-1.5.4.1-1.8-1-.1-.6-2-.9-.5.4-1.1-.7-.7.5-.7.1-.8-.8-.3-.6-.8-1.2.7-.7.4v-1.2l-1.5.2-1.4-.8-1.5 1.4-.9-.4-1.2.7v.1l-.3 1.3v.1l.4.5-2 1.4a22.3 22.3 0 0 0-.5 2.3c0 .4-1.7 1-2.3 1.2a6.9 6.9 0 0 1-2 .1 8.8 8.8 0 0 0 .2 1.6 11.4 11.4 0 0 1 .6 2.5.1.1 0 0 1 0 .1 4.5 4.5 0 0 1-1 1l-.7 1 1 .7Z",
    "data-name": "Path 47139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861.7 603.5 2.3 1.2.6-1.6-.4-2.4-1.5-.2Z",
    "data-name": "Path 47140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.1 342.3c0-.1-2.5-6.7-2.5-7s1.5-2.2 1.5-2.6c.1-.4 1-2.1 0-3.1a8.5 8.5 0 0 0-2.5-1.7l.3-3.4v-1.1a8.5 8.5 0 0 1 .4-1.7 7.4 7.4 0 0 0 .2-3.3l-1.6-.6-.6-1.9-2.3 1.2-1-.2s-1.9 2.8-1.6 4.8a.4.4 0 0 0 .1.3 1.8 1.8 0 0 1-1.5 1.9l-.9 2.1-2.4-1.8a10.6 10.6 0 0 1-3 .4h-.2c-.6-.4-1.5-3.4-1.5-3.5l-1.5 1-.9.4 1.4 2a9.8 9.8 0 0 0 1.8 1.7h.1l.6.4a9.7 9.7 0 0 1 2.3 1.3c.5.4.8.7.7.8-.4.3-.2 2.5-.4 3.2-.2.5.3.9.5 1a.1.1 0 0 1 .1.1l-.3 1.3.6 1.8v.9l-.7 2.2.8 2.6a15.7 15.7 0 0 1 3 2c2.2 1.7-.6 3.6-1.9 4.7-1.2 1.1-4.6 5.7-6.4 7.2-1.8 1.4-.8 2.9-.3 4.6s.2 5.1.3 7.4 2.5 3.4 4.1 4.2c1.5.8 3.8-1.9 7.6-3.1a16 16 0 0 1 2.1-.5c2.2-2.7 7.6-9.6 8.4-11.1 1-1.9-3.3-4.6-3.3-4.6l1.2-1.6-1-1.1.1-2.8h-.9l-.3-.8.6-.8-.5-.4.2-2.6 1-.2Z",
    "data-name": "Path 47141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m829.4 553.5 1.1 3.4 1.3 1.8 3.6-.1 1-2.4h2.1v.6l3 .2.1 4.8.7 1.4.2 2.6 3.7-.8 1.1.7h1.8l.3 1.1 1.4.8h.3l1.8-.1.5-.7.5.9.3.5 2.1.8 1.5 1.3h1.2l.5-1.3-.4-1.1-1.4.2-1.4-.6.4-4.8-1-1.3 2-1.9 4-.4-1.6-3.3a5.3 5.3 0 0 0-1.4-1.2l-.4-4.5v-.1l-.7-3.6v-.5l1-1.9.4-.4.2-3.9.4-.4v-1.2l3.1-2.8-1.2-.2v-2.9l-2.6-2.5-.6.7-1.2-.4-.7.6-2.6-2.1h-.5l-1 .1-1-.4-1.4-.4-.8 1.2-.6-.1-.2-.4h-1l-1.8 1.2-.6-.3-1-.1-.7 1.7-1.4-.2-3-.8-1.5-1.3-1.6.1-1.5 1.6a7.8 7.8 0 0 1 .1.9 3.4 3.4 0 0 1 0 1 2.8 2.8 0 0 1-.5 1.2c-.4.4-1 3.3-1.2 4a25.4 25.4 0 0 0 0 3.9l-2.2 1.5s-.4.4-.4.7c0 .2-1.5 1.5-1.5 1.5l.1 3.1-3.2 3-.6-.1-.2-1.3-1.2.1-.7 1.2-.4-.3-.3-.2-.3.2-1 .8-.2 1.7h-.8l.4.8 9.3-.6Z",
    "data-name": "Path 47142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.8 542.7-1.2.5-.7.6-.5.3-1 1.9.1.5 1.6.1.6-.9 1 .1.3.1.8-.7-.6-1.3Z",
    "data-name": "Path 47143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.6 546.9h-1v-1.1l-.9-.1-.6.9-1.6-.1.7 3.6 1.5.1 1.8-2.3Z",
    "data-name": "Path 47144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856 424.6 1.4-.9V422l1.4.3a.4.4 0 0 0 .5 0c.3-.2.3-.7.3-1.1 0-.6-.8-.7-.8-.7v-1.6l-.8.2.1-2.3a7.1 7.1 0 0 1-2-.3 5.3 5.3 0 0 1-1.5-1.2l-2 .1a.5.5 0 0 1-.2.4c.7.9 2 2.4 2 2.6a18.3 18.3 0 0 1 1 2 .8.8 0 0 1 .1.3l.4 3.9Z",
    "data-name": "Path 47145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844.4 430.7 5 .4a13 13 0 0 1 2.6-1.7 22.5 22.5 0 0 1 4.4 1.4 4.4 4.4 0 0 0 .6-1.6c.1-1.1 1.6-1.3 2.1-2.6a1.4 1.4 0 0 0 .2-.6c-.4-.3-.8-.7-1-.7-.3 0-.9.6-1.5.6a1.1 1.1 0 0 1-.9-.6v-.7l-.5-3.8a.4.4 0 0 1 0-.3 18.3 18.3 0 0 0-1-2l-2-2.6a2 2 0 0 1-1 .9 4 4 0 0 1-1.9.4 3.9 3.9 0 0 1-1 .6.8.8 0 0 1-.5-.1 2.7 2.7 0 0 1-.6-.7H845l-.5-.4-1.3.7-1.8 1.6c-.4.4-.9 3.1-1.5 3.4s-.6.7-1.9.7h-.2l.8 1v1.3l1.6.7-.2 1.4 1 .8.5.2 1.1-.8.3.3v1.4l.5.2 1 1.2Z",
    "data-name": "Path 47146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856.8 590.1-1.2-.1-.8-.6v-2l-1 .3-.5-1.6h-.6l-1.2-.7-1-2 .3-1.5a1.7 1.7 0 0 1 .3-.4l-3.3-.1-2.5 1.3-.9-1.1-5 .9s.4 7.2-.3 8.9c-.4 1-1 .9-1.4.6a2 2 0 0 1-.5-.5v6.6l1.8 2.3-.3 2.6h2.4s2.3-1.6 2.3-2.1a8 8 0 0 1 .6-2.2c2.6 1.6 5.6 1.9 6 .6s-.5-1.9 1-1.9a2.4 2.4 0 0 0 2.2-1.9c0-.4 1.3-2.9 2.8-3.1a11 11 0 0 0 2.6-.6l-.6-1.3-1.2-.4Z",
    "data-name": "Path 47147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858 611.3a1.5 1.5 0 0 0 .3-1.5 3.4 3.4 0 0 0-1-1.9h-.2l-.2-.2v-.1h-.6a.4.4 0 0 0-.3.1l-.4.2a.5.5 0 0 0-.2.4l-1.4 1.3-.5 1.6.1.4a2.8 2.8 0 0 0 .8 1.1c.6.6 2.7-.8 3.5-1.4Z",
    "data-name": "Path 47148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.2 379 2.7 2.5 1-.6.3.6.7-.1.8-2.2a21.7 21.7 0 0 1-.7-3.5l.1-.3a11 11 0 0 1 1.6-1.8l-.4-.9a2.4 2.4 0 0 1-1.4.2 27.2 27.2 0 0 0-7 .3c-1.3.3-1.9 1.8-1.6 3.4.2 1.6 2 1.6 2.1 2.3v.6l1.8-.5Z",
    "data-name": "Path 47149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.1 436.3h1.6c-.5-.7-.7-1.3-.2-3.2a9.2 9.2 0 0 1 1-2.3 22.5 22.5 0 0 0-4.5-1.4 10.5 10.5 0 0 0-2.6 1.7l-5-.4-.5-1.2-.5.4v.9l-1 .1 1.3.8.6.4-.9 1-.7 2v.2h.3v.5l.8.1-.2 2.3.2-.1 1.8-.7 1 .1 1.1.1 1.1.4h1.5l.2-.4.3-.4.8-.4.5-.2 1-.5 1 .2Z",
    "data-name": "Path 47150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846.8 386.7 1.6-1v1l.7.1 1.1.1 2 1.9v-.1l1.1-.7 1 .4 1.4-1.4-.2-3.1-1.2.3.3-2.1-.7-.7v-.1l-.7.1-.3-.6-1 .6-2.7-2.5-1.8.7c0 1.2-.3 3.4-.9 3.5-.6.2-1.3-.2-2.3-1.5s-2.6-.5-3.2.1a9.5 9.5 0 0 0-1.5 5.5h.5l2-1.6h.2l2.2.5 2.4.6Z",
    "data-name": "Path 47151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844 515.9-2.7.1.2 1.1-3.4 2.7-3 .2a4.2 4.2 0 0 1 .3 1c0 .3-4.3 2.2-5 2.3-.3.1-.5-.1-.7-.4a1.7 1.7 0 0 1-.2-.5l-1 .8-1-.1h-.3a.5.5 0 0 1-.2.6l-2.4 2.4.7 4.2 2.4 2.5 1.2 1.3 1-2 4 .2.1-1a7.8 7.8 0 0 0 0-.9l1.4-1.6 1.6-.1 1.5 1.3 3 .8 1.4.2.6-1.7 1.1.1.6.3 1.8-1.2h1l.2.4.6.1.8-1.2 1.4.4 1 .4 1-.1h.5v-.1l.1-1.4-1.9-.5V525l-2.5-2.1-1-1.8-3-.7.1-2.3-1.4-2.2Z",
    "data-name": "Path 47152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844 394 1.3 1.7a5 5 0 0 0 2.1-.1c.6-.2 2.3-.8 2.3-1.2a15.7 15.7 0 0 1 .4-2.3l2.1-1.4-.4-.5v-.1l.3-1.3-1.9-1.9-1-.1-.8-.1v-1l-1.6 1-2.4-.4-2.2-.5h-.2l-2 1.6h-.5v.8l.2 2.3.8.1 1.4.9 1.4-.1.3 1.1-.5.6.1 1.1.8-.2Z",
    "data-name": "Path 47153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.3 437.9h-1.5l-1-.4-1.2-.1-1-.1-1.8.7-.2.1-3.9 1.5v.1l-1 1.5-.6.4-1.8 1.2a5.8 5.8 0 0 0 .4 1.8c.5 1.2 2.1-.1 2.4.3.4.4.6 1.2 1.2 1.6a1.8 1.8 0 0 0 1 .4 2.1 2.1 0 0 1-1.3.5c-.6 0 .6 1.6 1.2 2.8a4.5 4.5 0 0 0 3.1 1.8c1 .2.1-1.5.1-2.1 0-.6.7-1.2.2-1.6s-.3-.7.2-.4 1.2.4 2.6-.3-.5-1.6-1-2.1a8.4 8.4 0 0 1-2.7-3.8c-.7-1.8.5-.7 1.5-.7 1 .1 1.4-.5 1-1s1.6-.7 3.3-.6a1.5 1.5 0 0 1 1.1.4l1.1-1.1.5-.9-.5-1.3-.8.4-.3.4-.3.6Z",
    "data-name": "Path 47154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846 455.5a10.7 10.7 0 0 0 4 1h1a1.4 1.4 0 0 0 .5-.2c.2-.1.2-.3.2-.5a.6.6 0 0 0-.5-.3l-1-.2-1.7-.3a6.2 6.2 0 0 0-2.7-.1l-.2.1a.2.2 0 0 0 0 .3l.3.2Z",
    "data-name": "Path 47155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.1 608.1a8.6 8.6 0 0 0 1.7.3 2.7 2.7 0 0 0 2.6-.8c1-1.3 1-1.9 1-3.7v-12.5a2 2 0 0 0 .4.5c.4.3 1 .3 1.4-.6.7-1.8.3-8.9.3-8.9l5-.9 1 1.1 2.4-1.3 3.3.1.2-.3v-.2l-2.4-.3-3.2-.2-1 .1a17.3 17.3 0 0 0-2 .4c-.6.2-4 .4-4.8.5a9.9 9.9 0 0 1-1.7-.2l-1.6-.4-.7-.7h-10.3l-1.3-1.2a20.4 20.4 0 0 0-3 1c0 5.5 5 10.1 5.7 11.8.8 1.9.3 9.8 2.3 12.9l2 3.2 2-1.8c-.5 0-.7 1.7.7 2.1Z",
    "data-name": "Path 47156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848.4 470.7-.4-.4-.5-1.2.6-1.1v-1.5l1.3-1.9-5.2-2.2c-7.4-3.2-6.7 3.2-6.7 3.2.1 2.2-1 3.1-2.5 2.7-1.4-.3-1.4-1.4-3.6-1.6a4.7 4.7 0 0 1-4.3-2.9c-.6-1.6-6.6-2.1-8.9-3l.1 2.3-2.9 1.9.1 2.3-1.7 1.6-.5.5a10.2 10.2 0 0 0 1 2.1l.1 6.7-1 .7 1.4 3.7 3.1 1.2a24 24 0 0 1 1.3 2.1v.1l3 .5c.5.1 1.6 1.6 2.1 1.6a15.1 15.1 0 0 0 1.8-.9l.4-.2.2-.1h.1a6 6 0 0 1 2-.5c.4.1 4 1.9 7.7 3.9l9.5 5.1v-1.2h2.4v-23.5Z",
    "data-name": "Path 47157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m825 397.6-.4.8-.7 1.5 1.1.8.1 3.4.7.8v1.7l.4.4a7.4 7.4 0 0 1 2.3.4l1.2 2.3a.1.1 0 0 0 .1.1c.3 0 .7-1.3 1.2-1.3a.6.6 0 0 1 .5.3v.1a1 1 0 0 1 0 .6l2.5.7.2 1.6v.1l1.5-.5.7 1.5s1.4-.8 2-.4a1.4 1.4 0 0 0 1 0l.1-.2 1.1-.1.8.6 1.6.5h.1l.2-.1-.4-1.3 1.5-2.1.6-.9 1-.1.1-2.4-.6-.2.2-.6-.7-.5v-2.3l-1-.7.5-1a9.1 9.1 0 0 0 1-1 .1.1 0 0 1 .1-.1 22.7 22.7 0 0 0-.6-2.5c0-.5 0-1.1-.2-1.6l-1.3-1.7h-.5l-.9-.1-5.6-.3a3.7 3.7 0 0 1-1.4.7c-1.7.4-1.4-1.2-1.6-1.8s-1.4-.4-2.4-.2a29.6 29.6 0 0 0-4.9 2.8 2.5 2.5 0 0 1-2.2.2v1.9l1 .2Z",
    "data-name": "Path 47158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m827 492.7.8.6.2.1-.4 1.9-.4 6.8-3.4 3.7-1 1.3.3 2.3c.5.3.5.8.7 1.1l.1.1.7-.2s1.5.5 1.5 1v.5l.2 2.5.1.8a6.1 6.1 0 0 0 .5 1.2 8.3 8.3 0 0 0 .8 1.2h-3.5a.3.3 0 0 0-.3.4l.1.2v.1l.1.2a.1.1 0 0 0 .1.1 12.9 12.9 0 0 0 1.7 1.6 3.3 3.3 0 0 1 .6.8l.1.3a10.7 10.7 0 0 1 .7 1.9h.2l1 .1 1-.8a4.2 4.2 0 0 1 .2.5.5.5 0 0 0 .7.3 26.2 26.2 0 0 0 5-2.3 3 3 0 0 0-.4-1l3.1-.2 3.5-2.7-.2-1.1 2.6-.1v-.2l.2-1.1-1-.4v-2.3l-1.8-.1 1.1-1.6-.7-.7 1.1-.9-.2-.8 1.1-1.3.5-1.7 1 .1 1 .1-.2-9.2-9.5-5.2c-3.8-2-7.3-3.8-7.8-3.9a4.5 4.5 0 0 0-1.9.5l-.3.1-.4.2.8 5.2Z",
    "data-name": "Path 47159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.1 495.5Z",
    "data-name": "Path 47160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 578.9h.2l1.3 1.2h10.3l.7.7a9.4 9.4 0 0 0 1.6.4 8.8 8.8 0 0 0 1.7.2c.7-.2 4.3-.4 4.8-.5l2-.4-2.6-2.6-.4-8 4.5-.2.1-4.7-3.7.8-.2-2.6-.7-1.4-.2-4.8-2.9-.2v-.7h-2.2l-.9 2.4-3.6.1-1.3-1.8c-.2-.3-1-3.4-1-3.4l-9.6.8a35.5 35.5 0 0 1 2.5 7.8c1.4 6-2.2 9.6-3.4 15.9a6.6 6.6 0 0 0 0 2 25.1 25.1 0 0 1 3-1Z",
    "data-name": "Path 47161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.6 580.7Z",
    "data-name": "Path 47162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m845.3 339.1.7-2.2v-.9l-.7-1.8.3-1.3a.1.1 0 0 1 0-.1c-.3-.2-.8-.5-.6-1 .2-.7 0-2.9.4-3.2.2-.1-.2-.4-.7-.8a9.7 9.7 0 0 0-2.3-1.3l-.6-.4a14 14 0 0 1-1.9-1.7 11.5 11.5 0 0 1-1.4-2l-.7.3s-.7.3-.4.7-.4 3.1-.4 3.1l-4.2-1.6.3 1.8c.3 1.8-.9 1.9-1.9 1.8s-1.8 2.1-2.2 2.2l-.2.4a11.7 11.7 0 0 0 .2 3.2c.3 1.2-1.9 3.1-1.9 3.1v1.7l-2.5.9.2 4.8-1.6 2.6 1 3.9-3-.3-1.6 2.4s-.5 6.7.3 9.2a.3.3 0 0 0 .1.2.3.3 0 0 0 .1.2l.2.3a.8.8 0 0 1 .4.4 1.3 1.3 0 0 1-.4 1.7s-.5-.3-.3.6a1.7 1.7 0 0 0 .2.5l.1.4c.4 1.6-.3 4.2-1.3 4.6l-.7 3.7-.5.1a15.5 15.5 0 0 0 .4 2.1c.6 1.4 2.4 4.8 3 7.6a14 14 0 0 0 .5 2.8c.4 1.3 1 2.3 2.1 2.3 1.8 0 2-2.1 4.4-3s2-5.9 2-7.6 1.6-3.5 4-4.7c2.3-1.2.6-5.2-.5-6.3-1.2-1.1-2.5-2.2-2.4-4.6s3.1-7.3 5.6-9.6a10.5 10.5 0 0 0 3.7-6.5 19.4 19.4 0 0 1 2.6-6.1c.7-.9 2-.7 3.1 0l-1-2.6Z",
    "data-name": "Path 47163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841 435.7v-.6l1.4.1h.2l.1-.2.7-2 1-1-.7-.4-1.3-.8 1-.1v-.9l.5-.4-.6-.2.1-1.4-.3-.3-1 .8-.7-.2-.9-.8.2-1.4-1.6-.7v-1.3l-.8-1a15 15 0 0 0-2 .2 5.3 5.3 0 0 1-1 .7v1.7l.8.5-.7 1.1.6.5.2.2-.4.6-.4.4 1.2 1.2c-.3 0-.6 0-.7.2a6.6 6.6 0 0 0 .1 1.4l1.6 1.4 1 .5-.8 1 .7.6.4 1v.1l1.1-.5Z",
    "data-name": "Path 47164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m843.3 392.9.5-.6-.3-1.1-1.4.1-1.4-.9-.8-.1c.2 1 .2.9-.6 1a1.4 1.4 0 0 1-.6.2c-.3 0-1.2.3-1.3 1a2.1 2.1 0 0 1-.4 1.1l5.6.3h1Z",
    "data-name": "Path 47165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m838.7 437.1-.2 1.3 1.1 1.3 4-1.5.1-2.3-.8-.2v-.5h-.6l-1.3-.1v.6l-1.4-.1-1 .5Z",
    "data-name": "Path 47166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842 415.4-2.2-.1-.8-.4-1.4 1.4-1.2-.2v.5l-1.6-.3v1.1l-1.4.2-2.2-1-.2 1.3-1.3.3v1.9l-1 .4a14.6 14.6 0 0 0 1.5 1.3c.2.2.5.4.6.7a12.6 12.6 0 0 0 3.2 1.8 5.4 5.4 0 0 0 1.3-.7l1-.7 2-.2h.2c1.3 0 1.3-.4 2-.7s1-3 1.4-3.4l1.8-1.6-1.7-1.6Z",
    "data-name": "Path 47167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.7 412.5c-.6-.4-2 .4-2 .4l-.7-1.5-1.5.5v-.1l-.3.3-.7.2-.7.3v1.2h-1.4l-1 .8v1.5l.5.6 2.2 1 1.4-.2v-1.1l1.6.3v-.5l1.2.2 1.4-1.4.8.4h2.2l.7-1.7a.1.1 0 0 1 .1-.1 2 2 0 0 0 .6-.4l-1.6-.5-.8-.6-1 .1-.3.2c0 .2-.5.2-.7.1Z",
    "data-name": "Path 47168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m839.5 439.8.2-.1-1-1.3V436l-.5-1-.7-.6s-1.2.1-1.3.4l-.4.9a5.5 5.5 0 0 1 .4 2.8 28 28 0 0 0 0 2.9 6.1 6.1 0 0 0 .1 1.4l1.8-1.2.6-.4.8-1.4Z",
    "data-name": "Path 47169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.3 431.4a1.1 1.1 0 0 0-.8.7 7 7 0 0 0-.6 1.9 3.8 3.8 0 0 1 2 1.6 3.6 3.6 0 0 0 .3-.9c.1-.4 1.3-.4 1.3-.4l.8-1-.9-.5-1.6-1.4h-.5Z",
    "data-name": "Path 47170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.2 429.9-1.2-1.2.5-.4.4-.6-.2-.2-.6-.5-1.8-.7-1-.2 1 .2 1.8.7.7-1.1-.8-.4v-1.7a5.4 5.4 0 0 1-1.3.7 11.4 11.4 0 0 1-3.2-1.8l-.6-.7-1 .4-1.4.4v1l-.5.1-.5 1.2-.4-.1-1-.6-.2.6H823v.7a1.2 1.2 0 0 0 1.3 1.1c.4-.1.4-.9.7-.8a1.8 1.8 0 0 1 1 1.1 11 11 0 0 0 1.4 2.9c1 1.3 2.4 1 4 2.9v.1a3 3 0 0 0-.4-1.6c-.6-.9-3.3-3.9-3.3-3.9v-1.2s.7.8 1.2.7a2.6 2.6 0 0 0 1.1-.7 1.9 1.9 0 0 1-1 .7c-.7.1-1.3-.7-1.3-.7v1.2l3.3 3.9a3.2 3.2 0 0 1 .4 1.6 12.8 12.8 0 0 0 2.4 1.1 6 6 0 0 1 .6-1.9 1 1 0 0 1 .8-.7h.4a6.6 6.6 0 0 1 0-1.4c0-.2.4-.2.6-.2Z",
    "data-name": "Path 47171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m824 414.7.7.6.8-.1v-.7l.5-1.3 1 .4 1 .5.8.7 1.4-.1.1-.1 1.1-.8h1.4v-1.2l.7-.3.7-.2.3-.3-.2-1.6-2.5-.7v-.7a.5.5 0 0 0-.5-.3c-.6.1-.9 1.4-1.2 1.3a.1.1 0 0 1 0-.1c-.5-.5-1-2-1.3-2.3-.3-.4-2.3-.4-2.3-.4l-.4-.4a.5.5 0 0 0-.4-.2l-1-.1-5 2.6a5.5 5.5 0 0 1 .6.9l.1.2c.1.4-.4.9-.4.9l4 3.8Z",
    "data-name": "Path 47172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821 550.1.8.6.3.2.4.3.7-1.2 1.2-.1.2 1.3.6.1 3.2-3v-3.1s1.4-1.3 1.4-1.5l.4-.7 2.1-1.5a17 17 0 0 1 .1-3.9c.2-.7.7-3.5 1.2-4a2.5 2.5 0 0 0 .4-1.2l-4-.2-1 2-.6 2.1-2.5-.7-1.7-.2h-2.5l.2 2.2 2.5-.1.3 1.1-1.2 1v1.3l1.2.5-.2 2.1-.4 2.2-1 .1v-.7l-.7.6h-1l-.9-1.5-.2 1.6-2.5-.3.2 1.5 1.6 1-.9.7-.9-.5-.6 1.4 1.4 2.3 2.4-1.8Z",
    "data-name": "Path 47173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.1 421.1.3-.4 1-.4v-1.9l1.3-.3.2-1.3-.6-.6v-1.5.1l-1.5.1-.9-.7-.9-.5-1-.4-.5 1.3v.7l-.8.1-.7-.6-1.8.3v.6l-.7 1.4.2 1.8-2-1.1-.9.6-1.5.8-.5-.6-1.2-.2v.9l-.7-.1-.5-.7h-.9l.1 1.4h.4l.4.6h1.1l.3.3 1.4-.1.6-.7 2.1-.1v1.2l2.8.5 2.3.3a1.2 1.2 0 0 0 .8-.4l.1-.3 2.2-.1Z",
    "data-name": "Path 47174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m825.1 424.6 1 .6.4.1.5-1.2.5-.1v-1l1.4-.4 1-.4a19.5 19.5 0 0 0-1.5-1.3l-.3.4-2 .2-.2.3a1.2 1.2 0 0 1-.8.4 16 16 0 0 1-2.3-.3v1.2l.1.7.2.7v.2c.2 0 .1.4.1.8h2v-.9Z",
    "data-name": "Path 47175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.1 535.6h7.2l1.7.2 2.5.7.6-2.1-1.2-1.3-2.4-2.5a30.7 30.7 0 0 1-.7-4.2 13.6 13.6 0 0 1 2.4-2.4.5.5 0 0 0 .2-.6 10.7 10.7 0 0 0-.7-1.9v-.3c0-.2-.4-.5-.7-.8a12.9 12.9 0 0 1-1.7-1.6v-.1l-.2-.2v-.3a.3.3 0 0 1 .2-.4h3.5a8.3 8.3 0 0 1-.8-1.2 9.7 9.7 0 0 1-.5-1.1v-.8a22.9 22.9 0 0 1-.3-2.5v-.5c0-.5-1.5-1-1.5-1l-.7.2c.2.5.3 1.4.5 1.7l.3.6a6.5 6.5 0 0 1 .4 1.3v.2l-.8.4a8.4 8.4 0 0 1-1 .2l-.5.9a18 18 0 0 0-.8 2.1v.3a248806265960.6 248806265960.6 0 0 1-.3.2v.1l-.3.1h-.3v1.7l-.8.3-.2.1a25.3 25.3 0 0 0-1.2 3.6c0 .9-1.3.9-1.5.9s-1-.9-1.8-1a3.6 3.6 0 0 0-1.5.9l-1.9 1.7v2l-.9 1.4c2.7.4 3.4 2.6 3.4 4.6l2.3.4Z",
    "data-name": "Path 47176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.5 491.4c-1.8 1.4-3.6 2.8-5.3 4.4l-3.6.6.1 6.5-1.4 2.2-7.5.6.2 2.8 2.1 1 .1 1.4 2.3 1.3h1.2l1.8 1.2v-1.3a1.3 1.3 0 0 1 .1-.6l1.1-1.1 1.3-1.3s2.6-.4 3.8.5a3.6 3.6 0 0 0 3.5.4c.5-.2 1.1.3 1.8.8a2.6 2.6 0 0 0 1 .4.8.8 0 0 0 .4-.1c.8-.2 1.7-1 2.7-1.2h.3a24.9 24.9 0 0 1 4 .6 1.7 1.7 0 0 0 .4-.2c.5-.4 1.3-1.2 2-1.1l.3.1-.4-2.3 1.2-1.3 3.4-3.8.4-6.8.4-1.9-.2-.1-.8-.6-.8-5.4a7.6 7.6 0 0 1-1.8.9c-.4 0-1.6-1.5-2.2-1.6l-2.9-.5v-.1a251 251 0 0 1-9 5.6Z",
    "data-name": "Path 47177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.2 409.7.6 1-.3 1.1 1.1.8.4.7 2.6.1-1.3 2.5-.2 2.6 1.2-.3 2-.2 1.1.1v.3h1l.4.7.7.1v-.9l1.2.2.5.6 1.5-.8 1-.6 2 1.1-.3-1.8.7-1.4v-.6l1.8-.3-4-3.5s.4-.5.3-.9v-.2l-.8-.9 5-2.6 1.1.1.4.2v-1.7l-.7-.8V401l-1.2-.8.7-1.5.4-.8-.6-.3v-1.9a3.9 3.9 0 0 1-1-.6c-1.2-.7-.2-1.6-.7-1.7s-3.8 1.9-4.8 2.3-.4-1.3-.3-1.8c.1-.4-.7.2-1.6.2-.6 0-1-1-1.3-1.8l-2.6-.2a10.2 10.2 0 0 1 0 3.9c-.5.7-2.3 1.1-3.4 1.3l-.2 2.2v1.1l-.7.1.1 2.2-2.3 1 1 .9-.8 1.3.4.8v.9l.5 1-.6.9Z",
    "data-name": "Path 47178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 371.5c1-.4 1.5-3.1 1.2-4.6v-.4l-.3-.5c-.2-.9.3-.6.3-.6a1 1 0 0 0 .4-1.6.8.8 0 0 0-.4-.4l-.2-.3a.3.3 0 0 0 0-.2l-.2-.2c-.8-2.4-.3-9.2-.3-9.2l1.6-2.3 3 .3-1-4 1.6-2.6-.2-4.8 2.5-1 .1-1.8s2.2-1.9 2-3.1a11.3 11.3 0 0 1-.3-3.2.5.5 0 0 1 .2-.4c.4-.1 1.2-2.3 2.2-2.2s2.2 0 2-1.8l-.4-1.8 4.2 1.6s.7-2.6.4-3.1c-.3-.4.4-.7.4-.7l.7-.3 1-.4 1.4-1s1 3 1.5 3.5h.1a16.5 16.5 0 0 0 3.1-.4l2.4 1.8 1-2.1a1.7 1.7 0 0 0 1.4-1.9.4.4 0 0 0 0-.3c-.4-2 1.5-4.8 1.5-4.8l1 .2 2.3-1.2.6 1.9 1.6.6a7.4 7.4 0 0 1-.2 3.3 10.5 10.5 0 0 0-.4 1.7l1-.5.5-1.7 1.6-.8v-1.4l1 .6h1v-1.1a14.8 14.8 0 0 1-2.2-1.3c-.9-.7.5-1.7 2.2-2.3 1.6-.7-.9-2.3-1.6-2.5-.8-.2-5.4-2.3-6.5-2.3a21.4 21.4 0 0 0-7.3 1.8 36.1 36.1 0 0 1-8.9 3.6c-4.3 1.2-7.5 7.2-8.4 9.3l-2.8 5.9-.9 1.9-3.6 6.9a217 217 0 0 1-6.9 12.3c-1.9 2.8-6.9 5.5-6.9 5.5-3.4 3.1-4.7 4.2-4.2 5.4.6 1.2.2 7 .3 12.1s5.6 4.6 6.8 3.8a40.2 40.2 0 0 0 4.7-4.5c1.3-1.3 1.6-.2 1.8 1.2l.5-.1 1-3.5Z",
    "data-name": "Path 47179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m818.8 548.7 1-.7-1.7-1-.2-1.5 2.5.3.2-1.6 1 1.5h1l.6-.6.1.7 1-.1.3-2.2.2-2.1-1.3-.5.1-1.3 1.2-1-.3-1.1-2.5.1-.2-2.2h-4.2l-.2 2.4H814a1.9 1.9 0 0 1-.2.7c-.7 3-2.4 3.5-.7 5.6a42.6 42.6 0 0 1 4.1 5.4l.6-1.4 1.1.6Z",
    "data-name": "Path 47180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 527.1a24.5 24.5 0 0 1 1.8-1.7 3.6 3.6 0 0 1 1.5-.9c.7.1 1.6 1 1.8 1s1.5-.1 1.5-.9a25.3 25.3 0 0 1 1.2-3.6l.2-.1.8-.3v-1.7h.3l.2-.1a.1.1 0 0 0 .1-.1l.1-.1a199045012768.4 199045012768.4 0 0 0 .2-.2l.1-.2a18 18 0 0 1 .8-2.1l.4-.9a8.4 8.4 0 0 0 1-.2c.3-.1.6-.2.7-.4l.1-.2a2.8 2.8 0 0 0-.4-1.3l-.3-.6c-.3-.3-.3-1.2-.5-1.7a.1.1 0 0 0 0-.1c-.3-.3-.4-.9-.8-1.1l-.4-.1c-.6-.1-1.3.7-1.9 1.1l-.5.2c-.5 0-2.7-.7-3.9-.7h-.3c-1 .2-1.9 1-2.7 1.2l-.4.1a2.1 2.1 0 0 1-1-.4c-.6-.4-1.3-1-1.8-.8a3.6 3.6 0 0 1-3.5-.4c-1.2-.9-3.8-.5-3.8-.5l-1.3 1.3-1 1.1-.2.6v1.8c.2.9.5 2.7.1 3.4a.1.1 0 0 1 0 .1c-.5.7-.9 1.9-1.3 1.9a3 3 0 0 0-1 .4v6.7a11.5 11.5 0 0 1 5.2.6c2.1 1.1 0 4.1 5.4 3.3a7.4 7.4 0 0 1 2.1 0l1-1.4v-.1l.3-1.9Z",
    "data-name": "Path 47181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821 550.1-2.3 1.8a11 11 0 0 1 .8 1.5h.8l.1-1.7 1.1-.8.3-.2-.8-.6Z",
    "data-name": "Path 47182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.6 390.1a.4.4 0 0 0 .3.1c.8.1 1.4.6 1.4.9s-.3 1.2-.7 1c-.5-.2-1-.2-.7.4.3.5.6 1 1.2.7a2.6 2.6 0 0 0 1.3-2.3 5 5 0 0 1 .2-2.1c.2-.3 1-.2.7-1a.4.4 0 0 0 0-.3c-.6-1.1-.8-1.4-1.4-1.4a2.1 2.1 0 0 0-1 .4 2 2 0 0 0-1.3 2c.2.5-.3 1.3 0 1.6Z",
    "data-name": "Path 47183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.5 457-.2 4.2 2 1.6-.9.6v.4l-6 .3v2.1l1 .4v1.4l-1.6-.1-3 3-3.6-.2-2.5 1.5-1 .6v4l8.7 5.2.5.3 12.3 9.3 2.6 2.3 2.6 1.1v1.8l2.2-.4 3.6-.6a56.2 56.2 0 0 1 5.3-4.4l8.8-5.3a10.7 10.7 0 0 0-1.3-2.1l-3-1.2-1.5-3.7 1-.7v-6.7s-1.3-1.9-1-2.1a1.2 1.2 0 0 1 .4-.5l-1-5.3-2.4-1.2c-.6-.4-1.3-3.3-1.3-3.9 0-.5 1.4-1.4 2-2.1v-.2a4.3 4.3 0 0 0-.2-2.2l.1-2.2v-.5l1.1-1.6c-3 .2-7.9.8-12.4 1.5-5.5.8-9.7 3.3-13 4.1l1.7 1.5Z",
    "data-name": "Path 47184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.1 456.4v.2c-.5.7-2 1.6-2 2.1s.7 3.4 1.3 3.9l2.3 1.2 1.1 5.3 1.7-1.6v-2.3l2.8-1.9V461l-.4-.1c-2-1-1-3.3-.9-6.9.1-2.6-.5-3.5-1.3-3.9a5 5 0 0 0-1.2-.2l-2.5.2-1 1.6v2.4a5 5 0 0 1 .1 2.3Z",
    "data-name": "Path 47185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.6 535.6h-.5l-2.8-.5a9.7 9.7 0 0 1-.4 2.9h3.4l.3-2.4Z",
    "data-name": "Path 47186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.7 392.2a1.7 1.7 0 0 1 0-.7c0-.4-.5-1.6-.2-1.6s.5.6.8 1.3 1.5.1 1.7-.5v-.4c0-.5-.6-1-.9-1-.4 0-1 .4-1 .1s1.2-1.1 1.5-1.7a12.7 12.7 0 0 0 .6-1.8 19.2 19.2 0 0 1-1.5-1.4c-.3-.3.6-2.4.5-3.6 0-1.3-3 1.5-3.9 2a3.1 3.1 0 0 0-1.6 2.1 12.1 12.1 0 0 0 0 3.8c0 .6 1 1.2 1.1 1.8a6.8 6.8 0 0 1 .2 1.4l2.7.2Z",
    "data-name": "Path 47187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m814.5 420.5-.4-.6h-.5v-1.7l-1.2-.1-2 .2-1.2.3-1.4-.2.2 1.2-1.7 1-.7 2.2 2-.9.4 1.8 2-.1 1-1.2.3-.4 1.2 1.9.5-1.9.3.2 1.4.6.2-1.3h.6l.2-.7h.2l-.3-.3Z",
    "data-name": "Path 47188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 424.2v-.7l-.3-.7.1-1.2-2.8-.5v-1.2l-2 .1-.7.7-1.4.1h-.3v.7h-.7l-.3 1.2-1.3-.6-.3-.1-.5 1.8-1.2-1.9-.4.5-.9 1.1-2 .1-.5.5.7 1.3-.8 1.1.6.7v1.9l1.5.1v1.2a5.5 5.5 0 0 1 5-.7c1.8.7 2.4 3.6 2.8 4.3a1.4 1.4 0 0 1 .3.4 41.7 41.7 0 0 0 5.3 4.1c1.3.8 5.2 4 5.6 5.1a3.6 3.6 0 0 1-.5 3 1.1 1.1 0 0 0-.3.8.8.8 0 0 0 .4.7c.4.3 1.4-.8 2-2s1-2.3.3-3.3.3-1.8.6-2.1 1.5 1.4 2.3 1.9c.6.4.8-.6.8-1.2v-.3c0-.5-4.4-2.9-5.3-3.5s-.7-1.2-.7-1.2a15.5 15.5 0 0 1-2-.4c-.8-.3-4-4.5-4.8-5.5a6 6 0 0 1-1.2-3.2 3.2 3.2 0 0 1 2-2.7 1.1 1.1 0 0 1 .7-.3l.2-.1Z",
    "data-name": "Path 47189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821 449 1 .3a12.6 12.6 0 0 1 3.2 1.6c.4.3 1.6.6 1.7 0s-.2-1 0-1.8a3.5 3.5 0 0 1 .6-1.4l.2-.3c0-.1 0-.3-.4-.2l-2.7.6c-.9.1-2-.5-2.7-.4-1.5.2-1.3.7-1.3.7a.6.6 0 0 0 .4.9Z",
    "data-name": "Path 47190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 437.7h.2c.6-.1 1-2.2 1-2.8a.6.6 0 0 0 0-.4 1.9 1.9 0 0 0-.8-.6 2 2 0 0 0-1.5 2.3c.2 1.1.6 1.5 1.1 1.5Z",
    "data-name": "Path 47191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 445.1c.3 0 .7-.3 1-1.1 1.4-6.1-.8-5.4-.8-5.4h-.2c-.6.1-1.6.5-1.7 1.3a9.9 9.9 0 0 0 .3 4.2 1.5 1.5 0 0 0 1.3 1Z",
    "data-name": "Path 47192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 429.2v-1.9l-.7-.7.8-1.1-.7-1.3.5-.5-.4-1.8-2 .9.7-2.3 1.7-.9-.2-1.2 1.5.2.2-2.6 1.3-2.5-2.6-.1-.4-.7-1-.8-.2-.1-1.3-.1h-.4l-1.2-.5-.6-1.9-.6.9-.6-.1-.2-1.4-1.5-.1-.4-1.5-1-.2-.7-.9-1.6.6c-.8.4-.5 2.4-1.4 3s-2.4 2.2-3 2.6-1.8-.3-2.9-1.3c-1.2-1-.2 2.2 0 2.7.1.4-.6 1-1.5 1s-3.6-.6-5.3-.2-.5 2.1-.2 2.9 3 .5 4 1 3.2 2.5 4 6.4a7.1 7.1 0 0 1-2.2 6.5 25 25 0 0 0 1.7 1.7l3.3.9 2.1-.1a6.7 6.7 0 0 0 1.4.9l3.4-.1a5 5 0 0 1 .3-2.4c.7-2 4.3.2 6 .4 1.6.3 2.5-1.4 3.2-2.2v-1.2l-1.4.1Z",
    "data-name": "Path 47193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m801.7 405.3.2-.4 2 .3 1 .2.5.6-.2 1.1 1 .7v-.9l-.5-.8.8-1.3-1-.9 2.3-1v-2.2l.5-.1.1-1.1.2-2.1a1.5 1.5 0 0 1-.6.1c-.8.2-2.6.3-3.2.8-.5.4 0 1.3.1 1.9 0 .6 0 1-.6 1s-.5-1.6-.8-1.8-.6.7-.8 1.3a23.4 23.4 0 0 1-2.6 4.3l-.4.4 1 .6 1-.7Z",
    "data-name": "Path 47194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.6 411.8.3-1.1-.7-1-1 .5v1.5l1.3.1h.1Z",
    "data-name": "Path 47195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.3 409.7.3-.9-.5-1-1-.7.2-1.1-.5-.6-1-.2-2-.3-.2.4-.9.4-1-.6a5.6 5.6 0 0 1-1.7.9l.6.9 1.1.2.4 1.5 1.5.1.2 1.4.6.1.6-.9.6 1.9 1.2.5h.4v-1.5l1.1-.5Z",
    "data-name": "Path 47196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m771.4 512.3 2 1.5-.7 1.6 1.4.4.1 1.3 1.6.2 1.8-1.3 1 1.3.3-.1 1.1-.3v-.2l.4-1.8-.5-1.3 1.6-.8 1.6-1.8 1.8-1.6 1.2-1.6 1.5.2 3.3-2.2 1.8-.2 7.5-.6 1.4-2.2v-6.5l-2.3.4v-1.8l-2.6-1.1-2.6-2.3-12.3-9.3-.5-.3-3.8.1 2.2 20.4.7.6s.1 1.3-.2 1.6-11.7.2-11.7.2l-.9 1.2-.9-1.1h-1v1.9l-1.3-.1.8 1.2-.3 1.9 1.4.7v2.5l4.4.3.7-1Z",
    "data-name": "Path 47197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 514v-.5l-1.8-1.2h-1.2v1.6l-1.9.6-1.2.8v.3l-.4 1 .4.4.6.6 1 1.6v7.7a9 9 0 0 1 2.2-.3v-6.7a2.1 2.1 0 0 1 1-.4c.4 0 .8-1.2 1.2-1.9l.1-.1c.5-.8.2-2.6 0-3.5Z",
    "data-name": "Path 47198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 434.7a4.2 4.2 0 0 1-1.4-.9l-2 .1-3.4-.9-1.7-1.7a1.6 1.6 0 0 1-.7.4c-.9.1-8.4-.4-10.6-.7a4.7 4.7 0 0 0-4.7 1.7c-.6 1 .3 1.3.7 1.8a3.2 3.2 0 0 1 .3 1.4l.8-.3.2 1.1 3.6-.5v.9l1 .1-1.4 1.6-.4 4.1-1.3.2 1 .9a3.8 3.8 0 0 0 0 1 .6.6 0 0 1-.4.7 12.1 12.1 0 0 1 0 1.9 22.8 22.8 0 0 0-.3 2.6 3.4 3.4 0 0 1 2.7 1.6 4.4 4.4 0 0 0 1.3 1.4c.6.3 1.1.3 1.2-.1.3-.6 2.5-1.3 4.7-1.4s3-.8 5.3-3 1.8-3.6 1.3-4.2.3-2.2 1.6-4a3.9 3.9 0 0 1 3.3-1.9c1-.1 2.5-1.9 2.5-1.9a2.3 2.3 0 0 0 .3-1.9l-3.5-.1Z",
    "data-name": "Path 47199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.4 444c1.2 0 .7-1.8 0-1.9a2.3 2.3 0 0 0-1.6.6c-.5.4.4 1.3 1.6 1.3Z",
    "data-name": "Path 47200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m795 509.5-2-1-.2-2.8-1.8.2-3.3 2.2-1.6-.2-1.2 1.6-1.7 1.7-1.7 1.7-1.6.8.5 1.3-.4 1.8v.2l.8-.2.7 1.8 2.4-.6 2 .9v-3.1l3.3-1.1h3.2v.8h2v-.3l1.2-.7 1.7-.7.2-1.5-2.4-1.3Z",
    "data-name": "Path 47201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m796 519.2-1-1.6-.6-.6-.4-.4.3-1-1.9-.1v.9l.6.5v2.2l.5.2.1 5.8 1.1 2 1.2-.3.1-7.6Z",
    "data-name": "Path 47202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.6 525.1v-5.8l-.7-.2.1-2.2-.6-.5v-1.7h-3.2l-3.3 1.1v3.1l.4.3.7 2.6-1.2 1.9-1 1.4 1.1 1.9.1 1.8a23.3 23.3 0 0 1 3.3.4 25 25 0 0 1 5.4-2l-1-2.1Z",
    "data-name": "Path 47203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m772.6 472.8 1-.6 2.5-1.5 3.5.2 3.1-3 1.5.1.1-1.4-1-.4v-2.1l6-.3v-.4l.8-.5-1.9-1.6.2-4.2a6.5 6.5 0 0 0-1.8-1.5 7.7 7.7 0 0 1-1.5.2c-3.5.1-5-2-6-1.9-1.2.1.3 4-3 5.5-5.9 2.5-5.5 8.1-5.7 10.2-.2 1.6-4.6 4.1-6.9 5.8h9l.1-2.6Z",
    "data-name": "Path 47204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.8 518.9-1.9-.9-2.4.6-.8-1.9-.8.2-1 .3-.5.1-.9-1.3-1.8 1.3-1.6-.2-.5 1.9h.1l1.2.7v1.4l-.9.3.2 1.4-1 .3-.2.1.8 1-.9 1.2 1.5 1.1 1 .7-.3 3a3.2 3.2 0 0 0 1.6-.4c2.2-1.4 6.3-1.5 9.2-1.3v-1.8l-1.3-1.9 1.1-1.4 1.2-1.9-.7-2.6Z",
    "data-name": "Path 47205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m767.6 506.1 1-1.2s11.3.1 11.6-.2.2-1.6.2-1.6l-.7-.5-2.2-20.4 3.8-.1-8.7-5.2v3.1l-7.6.1.5 6-2.7 1.2v3.9H754a35.3 35.3 0 0 0 1.4 5.6 9.1 9.1 0 0 1 0 6.1l4.8-.7.5 1.5h1.2l2.3 3.2 1.3.1v-2h1l1.2 1.1Z",
    "data-name": "Path 47206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.7 404.9c2.6-.3 5.1-2.8 6.3-2.8s1.8-3.3 1.5-5.8a2.8 2.8 0 0 1 .1-.9l-.5-.2h-.7l-.7-1.5-1.2 1.2-.9-.8.1-.9 1.1-1.1 1-1.5a10.5 10.5 0 0 0-1.8.4 1.2 1.2 0 0 0-.8 1.6c.2.6.2 1.2-1.3 1.3-2.5.1-3.4-.2-3 .7a11.8 11.8 0 0 1 .8 4.9c-.3 1.3-2.6 5.7 0 5.4Z",
    "data-name": "Path 47207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.2 448.7c.4 1.6 1.3 1.7 2 1.5a4.9 4.9 0 0 1 1.2-.1 22.8 22.8 0 0 1 .2-2.6 6 6 0 0 0 .1-1.9.6.6 0 0 0 .4-.7 3 3 0 0 1 0-1l-1-.9 1.3-.2.4-4.1 1.3-1.6-1-.1.1-.9-3.6.5-.2-1.1-.8.3.2 2.9c.2 1.1-1.3 4.7-1.8 5.5-.2.9.8 2.9 1.2 4.5Z",
    "data-name": "Path 47208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.5 381.6c-.4.8 1.3 1.5 1.7 1.7s0 1.2-.5 1.9-.5 1 .1 1c.5 0 1.2.2.6.7-.6.4-1.3 1.2-1 1.5.2.2 1-.3 1 .3s.2 1.2.6 1.2c.5-.1.8-1.3 1.4-1.3s.2 1.3-.2 2.1a1.3 1.3 0 0 0 .6 1.6 25.7 25.7 0 0 1 2.8-.6c.7 0-.2 1.4-.5 1.6s1.1 1.3 1.1 1.3c.8.5.5 2 .2 3s-2 .2-2.9.2 0 1.5.6 1.9c.6.4-.2 2.2-1 2.5a1.8 1.8 0 0 0-1 1.7c0 .5 1.6.4 2 .6.4.3 2.2.1 3 .5s-1.7.7-2.9.7-2.6 2.8-3.3 3.4.8 1 1.4.6a1.8 1.8 0 0 1 2-.4c1.2.3 1.3-.6 1.5-1.3s3.7-.4 5-.3a10.3 10.3 0 0 0 5.3-1.6c1.5-1-.2-.7-1-1.1s1-1.5 2.2-2.8-.6-3.1-1.8-3c-1.2.1-.9.1-1.2-.6s0-1.5-.6-1.8c-.4-.3-.6-2.7-.6-3 0-.3-1.6-.9-1.8-1.2a29.8 29.8 0 0 0-3.6-3.5c-.8-.4-.6-2.1-.4-3 .1-.9 2.1-4 2.4-5.1s-2-.9-3.5-.6c-1.5.3-1.3.2-1.3-.2s1.5-2 2.2-3.1-4-.5-5-.4-.2 1.6-.7 2.7l-.8 1.6c-.3.6-.6.4-.6-.3-.2-.6-1 .2-1.5.9Z",
    "data-name": "Path 47209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m773 525.6 1-1.2-.9-1 .2-.1-.7-.4-.9 1.3-.6-.4-.5-2.3h-1.8v1.1l-2.9 2.6c2.8 2.4 6.6 5.1 9.2 5.2l.3-3-1-.7-1.4-1.1Z",
    "data-name": "Path 47210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m771.1 523.8.6.4 1-1.3.6.4 1-.3-.2-1.4 1-.3v-1.4l-1.3-.7.4-1.9V516l-1.5-.4.6-1.6-1.9-1.5-.6 1-4.5-.3v-.9l-4.9-.5-.3 2.4-1.8.1-1 1.2a10 10 0 0 1 3.6 4.5h.1l.8.1 3-2.8 2.1 1.6 1 2v.6h1.8l.4 2.3Z",
    "data-name": "Path 47211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m763 487.2 2.7-1.2-.5-6 7.6-.1v-4.6h-9a3.7 3.7 0 0 0-1.3 1.2c-.7 1.3-6.4 9.3-7.5 11.3a4.5 4.5 0 0 0-.7 3.2h9l-.3-3.8Z",
    "data-name": "Path 47212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768 518.9-2.3-1.6-2.9 2.8-.8-.1a9.6 9.6 0 0 1 .4 1.7 15.4 15.4 0 0 0 3.5 3.7l2.8-2.6.1-1.1v-.6l-.9-2.2Z",
    "data-name": "Path 47213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.5 502.8a20.5 20.5 0 0 1-2.2 3.9 14.3 14.3 0 0 0 .4 2.2l1.6.3 2.6-.1h1.5l1.2.6.3.1.6.1-1.3.8-1.9-.8-1.5-.1v1l-2.5-.1a8.3 8.3 0 0 0 .7 1.3l5.5-.3 1-.1 4.8.5.1-1.6-1.4-.7.3-1.9-.8-1.2-2.3-3.2H761l-.5-1.5-5 .8Z",
    "data-name": "Path 47214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.3 281.1c6.6 18 12 22 12 30.3s-5.8 20.7-3.2 28.6 16.3 33.8 21.1 31.2 7.5-20.7 12.3-25.1 9.2-14.5 18-16.7 20.2-5.3 21.1-18.9c.5-7.9 2.2-21 3-34.5h-86.2l2 5.1Z",
    "data-name": "Path 47215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m760.6 509.7-1.2-.6H758l-2.6.1-1.6-.3.6 1.8 2.4.1.1-1 1.5.1 2 .8 1.2-.8-.6-.1-.3-.1Z",
    "data-name": "Path 47216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762 344.7a27.7 27.7 0 0 0-2.7-4.8c-1-1.2-2.4-1.6-3.4-2.4-1-.7-1.9 1.2-1.9 2.5s-1.2.3-2.4-.4-2-.6-3.2 1.2-.4.9-1-.3-1.2.1-1.5 2.2-2-1.2-2.3-2.6a2.5 2.5 0 0 0-2.9-1.6c-.6.3-1.8 1.9-2.9 4.1-1.2 2.2.4 1.8 1.2 1.8s2.8-.4 3.4.3-1.5 1.5-3.8 1.8 1 1.3 2.8 1.3 1.5 1.8 1.5 2.6-1.8 1.6-1.9 2.4c-.2.7 3.5.1 4.8.4s3 1.5 4.5 2c1.6.6 6-4 8.6-5.3 2.7-1.4 2.7-3.3 3-5.2Z",
    "data-name": "Path 47217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 512a8.6 8.6 0 0 0 2.8 2.9l.6.4 1-1.2 1.8-.1.3-2.4-.9.1Z",
    "data-name": "Path 47218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.4 547c-3-.1-11-3.4-16-5.1-5-1.8-5.6-5.3-7-9.1a7.2 7.2 0 0 0-2-2.5l-2.5 5-3.2.2-1.2-.6h-2.8l-.3.9-1.4.2-3.2.5-1.6 1.2-1.8-1.1-1-2.9.6-2.5-1.3-1 .5-1.2-1.9-.4a3.4 3.4 0 0 1 .1 1c0 .3-.8.7-1.4.9a3.2 3.2 0 0 0-.6.2l-1.8.3-1.3.8-4.4-1.1 2 2.1.2 1.9 1.1-.2.6.8s-2 1.2-2 1.8c0 .2-.5.4-1 .7a9.9 9.9 0 0 1-4 1c-1.7-.2-1.4-2.5-1.4-2.5l-.4-.5-2.9 1-3 .1v1l1 1.3h-2v1.3l1.8 2.5-.6 3.3-.6 3-.7.6s-4.4.9-5.3 1.6-1.5 3.5-1.5 3.5l-1.6 2.1 1.6 2.8.1 2.2h1.5l1.2.9 2.1-.3 1.3-.9-.2 3.5 2.6.2h.2l2.2.1 4-2.8.4-.3h2.6l.3 5 1.6.9 2.6.4 3.2 2.2 3 .4.5 3.2-.9.6.7.6.1 2.1 4.1-.1v1.8l1.8 1.9a3.1 3.1 0 0 1-.3 2.1 11 11 0 0 0-.6 2.6v1l.1 4.7h4.2l2 2.1-.4 2.3 2.5.3-.2 4 1.4.4-.3 3.8-4.3 1.9-3.8 4.7-.2.7 1.7-.1 1.8 1.8 1.3.3 4.4 4 .5 3.8a92.4 92.4 0 0 0 8.6-11.9c3.5-5.6-1.4-12 9.5-14.3 11.7-2.5 12-7.3 13.6-15.8 1.8-8.5-.5-8.4 9.1-18.5 6-6.2-4.4-14.3-11.4-14.4Z",
    "data-name": "Path 47219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670.8 535.6 3.2-.2 2.4-5a24.8 24.8 0 0 0-5.4-3.2l-1.6 2.6 1.3 1.9-1.2 3.3h.1l1.2.6Z",
    "data-name": "Path 47220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667.6 613.6-1.3-.3-1.8-1.8-1.7.1-1.3 4-.6 6 .5 1c1.1 0 6.6 2.7 9 .7a18 18 0 0 0 2-1.9l-.5-3.8-4.3-4Z",
    "data-name": "Path 47221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670 600.2-.9-.2.2 2-2.4 1.8-1.9 1-4.5-.4a19.5 19.5 0 0 0 2-4c.2-.8.2-1.4-.2-1.6a105 105 0 0 1-5.9-3.4l-1.8-.9-2.6-2-.9-1.5-2.6-.1-.9 2.3-1.3-1.8-1.9-.1-1.2-.4-2 2.2-.3 2.9-2.3 1.3-.3 1.8.1 3.8-1.9 3.5-1 .2.3 4.8v.5l-1.8 1.5.2 4.1 1.2 2s-.3 4-1.3 5.7c-1 1.8-2.2 2.6-2 4.7.1 2 1 4.7.1 5.4s-1.3 9.8-1.3 9.8l-1.5.7 1 2.5 1.1.9-.6 2.2 1 .9-.7 1.3.4 1.4-.7 3.7a17.5 17.5 0 0 1-1.2 3.2c-.9 2-1 4.7-1.6 5.1-.3.2-.5 1.8-.6 3.2a4.5 4.5 0 0 0 .2 2.4 8.6 8.6 0 0 0 1.6.1l.6 3.7a2.1 2.1 0 0 0 1.3 1.3 1.3 1.3 0 0 0 .6.1 59.7 59.7 0 0 1 6.1 1v.3h1c-1.3-3-2.6-6.5 3.4-12.3 4.8-4.7.3-4.8-1.2-8s3.2-3.7 4.7-6.3c1-1.7 1-8 1-9.7 0-1.3 6.3 1.5 6.2-5.1 0-3.5 7.2-1.8 10.1-4.2 5.1-4.4-3-8.9-1.6-10.9a.3.3 0 0 1 .2-.1l-.5-1 .6-6 1.3-4 .2-.7 3.8-4.7 4.2-1.9.3-3.8-1.6-.2Z",
    "data-name": "Path 47222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.5 529.6.8 1.5 2.6 4.9 1.4-.2.3-.9h2.8l1.2-3.3-1.3-1.9 1.6-2.7a41.9 41.9 0 0 0-7-2.6v.9l-.4 3.1-2 1.2Z",
    "data-name": "Path 47223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667.7 595.9.3-2.3-1.9-2.1h-4.3v-5.7l-2.2-1.1-6.6.6-1.9 5.7.8 1.5 2.6 2 1.8.9 6 3.4c.4.2.3.9.1 1.6a17.7 17.7 0 0 1-2 4l4.5.4 2-1 2.3-1.8-.2-2 1 .2.1-4-2.4-.3Z",
    "data-name": "Path 47224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.2 529-.5 1.2 1.3 1-.5 2.5 1 2.9 1.8 1.1 1.6-1.2 3.2-.5-2.6-4.9-.8-1.5 2.1-1.1.3-3.1.1-.9a4.3 4.3 0 0 0-1-.2 15 15 0 0 1-5.2-2.8l-2 1.5a28.6 28.6 0 0 1 .5 3.1c0 .6-2.4 1-2.4 1a10.6 10.6 0 0 1 1.1.9 2.5 2.5 0 0 1 .4.7l1.6.3Z",
    "data-name": "Path 47225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.7 675.4a22.6 22.6 0 0 1-3.7.1 2.6 2.6 0 0 0-2 .5c-1 .6-.4 1.3-.2 2.4 2.2.2 2.5.7 4.6-.3.7-.4 3.6-.9 3.3-1.6a1.8 1.8 0 0 0-2-1.1Z",
    "data-name": "Path 47226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.7 581.7 1 2.8 1.1.6-.9 1.5 1 3.7.5 3.1.7-.1 1-.1 2-2.2 1.2.4 2 .1 1.2 1.8 1-2.3 2.5.1h.1l2-5.7 6.5-.6 2.1 1.1a5.8 5.8 0 0 1 .6-2.6 3 3 0 0 0 .3-2.1l-1.8-1.9v-1.8l-4 .1-.2-2.1-.7-.6 1-.6-.7-3.2-2.9-.4-3.2-2.2-2.6-.4-1.6-.9-.3-5H643l-.4.3-4 2.8-2.2-.1h-.4l.5 1.6 1 1.6-.3 1.4v3l-.4.5-.4.5v1.8l-.3 1.4 1.1.5-1.2 1.1-.5 2.1 1.2 1Z",
    "data-name": "Path 47227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629 515.9-1.4 2.7c-.2.5.2.8.6.9l1 .2-.2 2a5 5 0 0 0 .6 2.4 1 1 0 0 0 1 .4h3.4l2.3 2.3 4.1-.3-.6 1.2-.4 3 1.2 2.2-1 .9 1.5 1.8.4.5s-.3 2.3 1.3 2.5a8.8 8.8 0 0 0 4.1-1 1.7 1.7 0 0 0 1-.7c0-.5 2-1.8 2-1.8l-.6-.8-1 .2-.3-1.9-2-2.1 4.4 1.1 1.3-.8 1.8-.3.6-.2c.6-.2 1.3-.6 1.3-.9a3.4 3.4 0 0 0 0-1 1.6 1.6 0 0 0-.5-.7 10.6 10.6 0 0 0-1-.9s2.3-.4 2.3-1a28.6 28.6 0 0 0-.6-3.1l2.1-1.5c-3.4-2.4-7.6-5.2-11.3-4.5-5.9 1.2-7.6-1.2-10.2-2.4a18.3 18.3 0 0 0-5.2-.9l-2 2.5Z",
    "data-name": "Path 47228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.2 690.4h1c5.5-.6-4.3-5-4.8-8.4a13 13 0 0 0-.9-2.8h-.9l.4 9.2a17 17 0 0 1 5.2 2Z",
    "data-name": "Path 47229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.6 539.2c.2.7 1.8.4 3.5.6a1.4 1.4 0 0 1 1.2.8l1.6.1 1.5 1.8 1 .6.6 1.1 1 1.6h4.3l1 .3 1 .3-1.3 2.4 2 .6.5-3 .6-3.3-1.8-2.5v-1.5h2l-1-1.3v-1l3-.1 3-1-1.6-1.8 1-.9-1.2-2.2.4-3 .6-1.2-4 .3-2.4-2.3h-3.5a1.3 1.3 0 0 1-.9-.4 5 5 0 0 1-.6-2.4l.1-2a2.3 2.3 0 0 1-.9-.2c-.4-.1-.8-.4-.6-.9a27.3 27.3 0 0 1 1.4-2.7l2-2.1h-.6c-3.5 0-6 3.2-7.6 4.7s-5.9 5-5.3 9.1c.5 3.4-1.5 7.1-3.5 9 1.2.6 3.4 2 3.5 2.5Z",
    "data-name": "Path 47230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.8 498.8a2.8 2.8 0 0 0 2.2.2c.7-.3 1.1-.8.4-1.2v-.1a3.9 3.9 0 0 0-2.8.2l-.3.3c0 .3.3.5.5.6Z",
    "data-name": "Path 47231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.6 498.1c.2-.1.4-.1.5-.3s-.2-.4-.4-.6a23.4 23.4 0 0 0-7.7-2.6l.1 4.5a36.6 36.6 0 0 0 7.5-1Z",
    "data-name": "Path 47232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636 578.7 1.2-1.1-1-.5.2-1.4v-1.8l.4-.5.4-.5v-3l.2-1.4-.9-1.6-.5-1.6-2.6-.2.2-3.5-1.3.9-2 .3-1.3-.9h-1.5v-2.2l-1.7-2.8 1.6-2.1s.6-2.8 1.5-3.5 5.3-1.6 5.3-1.6l.7-.6-1.9-.6 1.2-2.4-.9-.3-1-.3H628l-.9-1.4-.6-1-1-.6-1.5-1.8-1.6-.1a1.4 1.4 0 0 1 .2.6l.2 1 .2.6a.2.2 0 0 1 0 .3 9 9 0 0 1-3.2 3 12.9 12.9 0 0 0-3.2 1.9 7.9 7.9 0 0 0-1.8 2.9l-3-.6v-2.4l-.9-2.2-1-.4v.7c0 1.8-.3 7.3 1.8 9.1 2 1.8 6.4 16.4 17.3 22.9a9.8 9.8 0 0 1 3.8 4.5l1.6-.4 1.2-1.5.5-1.9Z",
    "data-name": "Path 47233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.6 611.9v-.5l-.3-4.8 1-.2 2-3.5-.2-3.8.3-1.8 2.3-1.3.3-2.9-1 .1-.7.1-.6-3.1-.9-3.7 1-1.5-1.3-.6-.9-2.8-1.2-.9-1.2 1.5-1.6.4c3.3 7.2 1.6 20-.8 30.5l2 .2 1.8-1.4Z",
    "data-name": "Path 47234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.7 679a43 43 0 0 0-6-1 1.3 1.3 0 0 1-.7-.1 2.1 2.1 0 0 1-1.3-1.3l-.6-3.7a8.6 8.6 0 0 1-1.6-.1c-.2-.1-.2-1.1-.2-2.4h-4.2a48 48 0 0 0 .1 5.5c.6 10.6 14 14.8 20.2 14.7a16 16 0 0 0-5-2l-.5-9.2-.2-.4Z",
    "data-name": "Path 47235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.3 670.3c.1-1.4.3-3 .6-3.2.6-.4.7-3.1 1.6-5.1a17.5 17.5 0 0 0 1.2-3.2l.7-3.7-.4-1.4.7-1.3-1-.9.6-2.2-1-.9-1-2.5 1.5-.8s.4-9.1 1.3-9.8 0-3.4 0-5.4c-.3-2.1 1-2.9 2-4.7 1-1.7 1.2-5.6 1.2-5.7l-1.2-2-.2-4.1-2-.2c-1 4.9-2.4 9.4-3.3 12.5-3 10.1-5.4 31.7-5.6 44.6h4.3Z",
    "data-name": "Path 47236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.8 548.5v2l3 .6a6 6 0 0 1 1.8-2.9 15 15 0 0 1 3.2-1.9 9 9 0 0 0 3.2-3 .2.2 0 0 0 0-.3c0-.1 0-.4-.2-.6 0-.3 0-.7-.2-1 0-.2 0-.4-.2-.6a1.3 1.3 0 0 0-1.2-.8c-1.8-.2-3.4.1-3.5-.6 0-.5-2.4-1.9-3.7-2.7a4.7 4.7 0 0 1-1.2.9c-2 1.3-2.8 5.9-2.9 8.1l1 .4 1 2.2v.2Z",
    "data-name": "Path 47237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.8 521.1a27.5 27.5 0 0 1 4 2.6c3 2.2 2.4-1.9 2.4-1.9a3.7 3.7 0 0 1 3-1c2 .1 1.1 2.2 2.2 3.9l2.1-3.5s-3-2.9-6-2.2c-2.9.7-4.7.8-6.8-.3l-.9 2.4Z",
    "data-name": "Path 47238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.5 498.9a36.2 36.2 0 0 0 5.7.2v-4.5l-2.9-.3v-.1c-.4-.3-1 .1-1.2.6a1.3 1.3 0 0 0 .8 1.2 4.1 4.1 0 0 0 1.6.2c.4.5-.2 1.3-.9 1.4h-2c-.7.1-1.3.7-1 1.3Z",
    "data-name": "Path 47239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.1 492.8c.4.5.4 1.3.8 1.7a2.4 2.4 0 0 0 1.4.5 23.6 23.6 0 0 0 4.6.2 3 3 0 0 0 1.3-.3.8.8 0 0 0 .4-1.1.8.8 0 0 0-.4-.4l-5.4-3.7c-1.7-1.1-3.5-2.3-5.5-2.2a8.9 8.9 0 0 1-2.3 0c-1.2-.4-2-1.8-3.3-1.8-1.2 0-1.9 1.2-3 1.6l-2 .4c-.7.2-1.4 1-1 1.6.5.8 1.7.2 2.7-.2a5 5 0 0 1 4.1.7 13.8 13.8 0 0 0 4 1.8c1.2.3 2.8 0 3.6 1.2Z",
    "data-name": "Path 47240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.1 499.6a2 2 0 0 0-.8-1.6 2.2 2.2 0 0 0-3 .3v.3a3.8 3.8 0 0 0 3.8 1Z",
    "data-name": "Path 47241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m603 516.1-1.3-.9-3.2.3a4.6 4.6 0 0 1 .5 2c0 1.2 2.2 1.1 3.7 2l3 1.6 1-2.3a2.2 2.2 0 0 1-.6-.3 3.3 3.3 0 0 1-1.7-3.1l-1.4.7Z",
    "data-name": "Path 47242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.8 506.3-.4.1-2.4.7-1.3-.4-1.6 2.1-1 .3-1.3.3-.6 3.2a1.6 1.6 0 0 0 .8 1.3 4 4 0 0 1 1.4 1.7l3.2-.3 1.3.9 1.4-.7a30.7 30.7 0 0 1 .5-5.3 8.6 8.6 0 0 0 0-3.9Z",
    "data-name": "Path 47243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 504.5v1l-1 2.2 1.8.9 1.8.6.1 1.4c.3.1.6.1.8.3a2.6 2.6 0 0 1 1 1.6l.5-3.2 1.2-.3 1.2-.3 1.6-2.1 1.3.4 2.4-.7.4-.1a3.8 3.8 0 0 0-2.4-2.4c-1.6-.9-5.9.2-7.6.2a1.1 1.1 0 0 1-.8-.3l-2.4.8Z",
    "data-name": "Path 47244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.7 508.6-1.8-.9-1.9 1.7 5.4 1.1v-1.4Z",
    "data-name": "Path 47245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593 498.2-.2.1-1.8 1.4 1 3.5v1.4l2.1-.6c-.6-.6-.2-1.9 0-3.7a10.5 10.5 0 0 1 .3-1.7l-1.5-.4Z",
    "data-name": "Path 47246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591 507.7 1-2.2v-1l-.2-1.4-.9-3.5h-3.2l-1 1.5 3 2.6-1 1-1.6.4h-2l-.4 2a5.8 5.8 0 0 0 1.5 1.1 9.6 9.6 0 0 0 2.8 1.1l2-1.6Z",
    "data-name": "Path 47247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.4 419.1c2.6-.4 4.7-1.9 4.8-.6.2 1.3 0 2 1.6 1.9s4.1 1.6 4.7.4-.2-3.9-.9-5.1c-.7-1.2.3-4.2-1.8-4.2s-5 .4-5-1 2.6-5.3 1.8-5.6c-.9-.3-3 .9-3 .9a49.7 49.7 0 0 0-5.8 11.4c.6.7 1 2.3 3.6 1.9Z",
    "data-name": "Path 47248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.7 369.8 1.1.3 2.6-1.8.7 3.1 2.4 2.4.2 1.8 1.7-1.4.5-.4v-1.7l2.2-.5.7-.2 1 2.6 2.5 2.6 4.4 8.3 4.6 2.2-1 3.5-2 2.9 1.1 1.6c2.1 3.2 4.5 7 6 9.8s-1 1.6-1.8 2.5c-.7.9 4.4 3.4 7.2 5.5a6.3 6.3 0 0 1 2 2.6l3 .8.5-2.9 62.6-.2 1-1.1.6 2.4h3.7l1.3 1.6 1-.7 1 1.2 1-.7 2.6.8 1.1-.1 2.3-1.1 8.6 6.1 1.2.5 1 1.6 2.2 1.7.8 4.6s0 2.7-.4 3.1l-1.6 1.8s-.4 1.4.5 1.6h.6a4.7 4.7 0 0 0 1.7-.3l6.2-2.8-.3-2.3 5.1-.1s1.6-2.7 2.3-2.9a8 8 0 0 0 2.1-1.5 8 8 0 0 1-2 1.5c-.9.2-2.4 2.9-2.4 2.9l-5 .1.2 2.3-6.2 2.8a5.2 5.2 0 0 1-1.8.3h-.6c-.8-.2-.5-1.6-.5-1.6l1.6-1.8c.4-.4.4-3.1.4-3.1l-.8-4.6-2.3-1.7-.9-1.6-1.2-.5-8.6-6.1-2.3 1.1-1 .1-2.7-.8-1 .7-1-1.2-1 .7-1.3-1.6h-3.7l-.7-2.4-.9 1.1-62.6.2-.5 2.9-3-.8a19 19 0 0 1 1.4 5.2c.4 2.1-1.9 14.6 0 21.3s6.7 13.4 7.7 14.7 5 3.2 7.1 5.3l.6.6 5.1-.6 7.3 3.2 7.8.7-.3-1.5 4.2.1 1.2 1.5a8.2 8.2 0 0 1 2.5 2.4c.5.9 2 3.5 3.1 3.6a.6.6 0 0 0 .4-.1 8.8 8.8 0 0 0 2-2.4 8.8 8.8 0 0 1-2 2.4.6.6 0 0 1-.4.1c-1-.1-2.6-2.7-3-3.6a11.4 11.4 0 0 0-2.6-2.4l-1.2-1.5-4.2-.1.3 1.5-7.8-.7-7.3-3.2-5 .6c2.2 2.8 6.1 10.1 6.4 10.7s-1.8.8-2 1.4 3 3.2 4.8 3.4c2 .2 2.3 4.3 5.7 7.6s2.5 0 1.6-.9-7.5-11.8-10-16.2.7-4.8 2.5-1.6c2 3.2 15.3 19.9 17 22.4 1.6 2.5-2.2 2.5 2.1 7.7s19.3 6.8 21.8 6.1c2-.6 4 2.1 6.1 3.9l.3-2h2.1l1.5-.4 1-1-2.9-2.6 1-1.5h3.2l1.8-1.4.1-.1 1.5.3c.8-2.3 2.4-5.2 3-6.8.8-2-4-.6-6.3-.6s-1.9 1.3-1.9 2.9-2.2 2.8-4 4-6.6.4-8.6-.7-3.2-5.9-4-8 .3-8 1-8.9a.7.7 0 0 0 0-.5l-3.7-.8-6-9.4 6 9.4 3.7.8c0-1-1-2.8 1.6-5.8 3.1-3.5 7.7-3.9 11.5-3.3 4 .6 3.5-.6 5.2-1.3 1.6-.8 8.4.6 11.2.4 3-.1 3.2 4.4 3.7 5.9.5 1.6 2.3 6.3 4.4 6.4s.1-7.6-1-11.5c-1.3-4 0-5.3.1-6.4s5.6-4.5 9.6-7.3c4-2.7 2-5.1 1.2-7.7s0-1.3.7-.9 1 .1 2-1.3 2.4-6 2.4-6c1-2.2 2.5-2 6-3.2s2.5-2.5 1.6-3.8.3-2.3.6-3.7l.2-.3-3.5-3.5s.3-1 1-1l1-.1c.2-.9.6-1.8 1-2.7l2.2-4.2.3-2.5a1 1 0 0 1-.6-.2c-.4-.4 5.1-4.1 8.1-6.1 3-2.1 9.7-.6 13-.7s8-5.1 10-7.6-2-5.1-3.7-6.3c-1.6-1.2-1.6-2.8-3.7-3.7-2-.9-4.5-5.8-6-9.4l-6.2-13s-.4-.7-1.2.3c-.9 1-3 6.5-6 7.1-3.3.7-4-3.3-4.3-6.3s.7-3.4-1.6-4.3-3.7-4.3-6.4-6.4-4.2.2-7.7-1.2-3 3.1-3.2 5.7 1.3 3.3 1 7.3c-.5 3.9-2.8 4.2.2 8 3.1 3.8 1.1 9.3-2 11.2s-3.6 2.1-1.6 5.1.3 9.3-2 9.4-4.9-9.9-5.6-13.3c-.6-3.4-8.4-4-12.5-5.5-4.2-1.5-11-7.7-13.5-11s-1.4-5.1-.9-7.8c.5-2.8 3.4-7.6 4.5-8.8a15.6 15.6 0 0 1 3.4-2.3c1.3-1.3-.2-2.2-.8-2.9-.5-.7 1 0 2.1-.4s.7-1.7 3.1-1.7 3-3.3 4-4.9 0-1.3-.9-1.3-2.3-1-4.3-2-.6-1 1.6.2 2.6.9 3.7.5a2.4 2.4 0 0 0 1.3-1.3 5 5 0 0 0 .5-3.2c-.3-2-.5-1.8 1.2-1.2 1.8.6 2.7.9 4.6 0a12.8 12.8 0 0 0 5.1-4.7c1.8-2.5-2-5.5-1.6-7.2.3-1.6 1.8-3.5-.9-6.9a3.7 3.7 0 0 0-3-1.6 5.6 5.6 0 0 0-4 2.2c-.8 1.1 1.7 4.2 1 4.4s-1.4 4.5-3.3 7.5-3.5-1.7-3.3-4.4.1-3.3-1.9-5.3-1.8 2.5-2.6 4.6c-.9 2.1-1.2-1.8-1.2-4s-.8-2-2.5-2.4l-4.9.6.4.3c2 1.9.8 5.6-.4 6.2-3.3 1.5-3 2-3 5.4.1 2.3-1.5-2.6-1.6-4.7 0-1-.8-1.4-1.7-1.5l-3-.1c-1.7-.1-.9 3.1-2.2 3.7s-3.6.1-8.5-.8-5.2-3.2-6.3-4.7-4.7 1.4-5.7 2.3 1.2 1.4.7 4.2c-.6 2.7-3-.3-4.3-1.7-1.2-1.3-7 1.1-10.6 1.1s-1.2-1.9.7-3c1-.5 1-1 .5-1.5a14.4 14.4 0 0 0-2.5-1.8c-2-1.2-4-.7-6.8-1.9a46.5 46.5 0 0 1-6.2-3.4c-1.6-1-4.4-2.3-5.2-.8s-1.4 1.4-2.4-1.5c-1-3-2 0-3.4 2.5s-2.3-2.2-3.5-4.8-1.8-.5-2 .7-1.7 1.3-2.5.8c-.9-.6-1-.2-4.4.8s-5.9 3.5-9.6 5.4c-3.6 1.9-7.4-2.8-10.9-3.2a5 5 0 0 1-1.7-.6l-.4 51 1.3.6Z",
    "data-name": "Path 47249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.6 418.9 1 .7v5.2h1l.7 2.4a37 37 0 0 0 4.6-1.9c2.2-1.3.7 1.2-.6 1.8s-1.8 2.6-1.5 4.2 3.8-1.6 4.8-2.2 4-2.5 7.5-4.4.4-3.5-.4-4.1c-.9-.6-3.4 2.5-4.5 2.4-1.2-.2-2-1.5-3.7-1.9s-1-1.5-.9-3.4l.3-4.8c0-.8-5.7 1-7.3 2.2a5.6 5.6 0 0 1-3 1.2l-.3 2.5 1.2.6 1.1-.5Z",
    "data-name": "Path 47250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.7 412.1c-.4-.9-1.8-.8-2.6-1.4l-.6-.5a1.3 1.3 0 0 0-.6-.1h-2c-.4 0-.3.4-.4.6.4.2.3.2.6.6a6.5 6.5 0 0 0 3.6 2.2c.7.1 1.6.1 2-.6a1.1 1.1 0 0 0 0-.8Z",
    "data-name": "Path 47251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.6 279.1a2.7 2.7 0 0 0 1.5 2.1 96.5 96.5 0 0 0 20.4 3.7c4.1.3 7.1.1 7.3-1 .2-1.7 1.5-5 1.3-7.7h-30.4a9.5 9.5 0 0 0 0 2.9Z",
    "data-name": "Path 47252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.1 333c-10-11-7.9-16.3-12.3-19.8s-12.3-11-15.8-14.5-1.8-2.2-8.4-6.6a15.3 15.3 0 0 0-8.2-3.1c-1.9 0-3 .8-3.2 1.8-.4 2.2-2.6-.4-4-.9a7.8 7.8 0 0 0-2.6-.4c-2.2 4-6 16.3-3.5 19.3 2.6 3.1 4.8 7.5 12.3 7.9h.4c7.2.3 11.1-1.3 14.1 1.3 3.1 2.6 16.7 12.3 10.6 18.9-4.8 5.1-13.4 12.3-12.4 14.3.3.6 1.4.7 3.6.2 12.7-2.6 19 12.3 23 11s5.2-7.5 1.7-13.6c-3.5-6.2-3-13.2.4-9.2s14.4 4.4 4.3-6.6Z",
    "data-name": "Path 47253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 335c1.3-.7 2-2.5 2.1-4 .2-1.2.2-2.7-.9-3.5-1.4-1-3.6-.1-4.3 1.3s-.3 3.1.1 4.6l1.5 1.3a1.2 1.2 0 0 0 1.4.3Z",
    "data-name": "Path 47254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.1 351.6a11.8 11.8 0 0 0-1-1.9c-2.2-3.1-4.4-1.1-7.6-6.8a1.9 1.9 0 0 0-2.2-.7l-.5.2a1.6 1.6 0 0 0-1 .8.6.6 0 0 0 0 .4c-.7 3.5-3.5 6.3-1.9 9.1 1.8 3.1 6.6 5.3 7.5 3.1s3.5-1.3 4.8-1.3c1 0 3-.3 2-2.9Z",
    "data-name": "Path 47255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 287.4c-1.6-.2-2-1-5.5-1-3.4.1-3 4.8-3.6 9.2a16.7 16.7 0 0 0-.2 3.2 25.8 25.8 0 0 1 .3 4.8l1.6.2c0-.3.8-.4 1.3-1.5a4.6 4.6 0 0 0 .2-4.4c-.6-1.5.6-.3 3.4-.4 3-.1 2-.6 4-6.1s.1-3.8-1.5-4Z",
    "data-name": "Path 47256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.5 314.9c.5-2.4-2.4-7.4-4.9-9.6-1-.9-1.4-1.2-1.4-1.5l-1.6-.2a4.3 4.3 0 0 1-.2 1.1c-.7 4-1.4 6-1.4 10.8 0 4.4 3.1 4.1 5.1 5.6l5-.6c-1.9-.4-1-3.3-.6-5.6Z",
    "data-name": "Path 47257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.8 280.8c1.1.6 2.7 1.8 3.8 1.8 1 0 1.5-.8 1-3.5v-.7a10 10 0 0 0-.8-2.4h-4.4c-1.2 2.1-1.2 3.9.4 4.8Z",
    "data-name": "Path 47258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6 322.9a34 34 0 0 0-2.8-4.5c-1-1.5-2-.9-2-.9-.5 1.3 0 3.5-1.2 4.2a4.3 4.3 0 0 0-1.4 1.2c0 .3 0 .6.6 1 1.2.8 3.3 2.5 5 2.8a2.2 2.2 0 0 0 .7-.1c1.5-.6 2.2-1.5 1.1-3.7Z",
    "data-name": "Path 47259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.8 306.9c1.7-2.2 4.1-5.5 4.1-8.1a3.1 3.1 0 0 0-.9-2.2c-2.6-2.3 1.2-9.9-2.9-10.2-2.7-.2-4.8 2.9-6.4 3.7a1.7 1.7 0 0 0-.8 2.1c.6 1.7 1.3 2.7-1 3.9-1.2.6-1.7.9-1.7 1.4 0 .7 1.1 1.8 3 4.4 2.8 4.4 4.2 7.9 6.6 5Z",
    "data-name": "Path 47260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.5 277.3c1.2 1.5 5 2.5 6.1-1.2h-7l1 1.2Z",
    "data-name": "Path 47261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.4 322.3-.3-.2a2.5 2.5 0 0 0-1.2-.1.4.4 0 0 0-.3.1c0 .1 0 .2-.2.3v.2c-.4.8-1 2.5.2 2.5a1.1 1.1 0 0 0 .8-.3 3 3 0 0 0 .4-.8 6.7 6.7 0 0 0 .6-1.2v-.2a.2.2 0 0 0 0-.3Z",
    "data-name": "Path 47262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 318.9c-3-6.6-6-7.5-7-12.3-.3-3-.4-6-.4-9-.2-5.2-.7-9.9-3.6-7.3-4.8 4.4-5.7 10.6-9.2 7.9-3.5-2.6-8.3-6.6-11.4-4.8a27.1 27.1 0 0 0-5.7 4.4c-1.8 3.1-2.2 7.5-.4 7.9s.4 3.1 1 4.8c.3 1.8 4 1.3 7.4 1.3s8.3 1.8 2.6 3.1-9.7 1.8-6.2 4.8c2 1.7 3.2 4.5 4.8 6.4a4.7 4.7 0 0 0 5.7 1.5c5.7-2.2 12-5.3 14.5-5.3 2 0 7.3 1.8 8.4-.2.3-.6.3-1.6-.5-3.2Z",
    "data-name": "Path 47263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.6 278.5c5.7.4 6.6 2.2 7 4s5.3-.4 9.7-1.8c4.1-1.2 8.3-.9 9.5-4.6H527c-.2 1.4.5 2.2 2.6 2.4Z",
    "data-name": "Path 47264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.5 287.3a38.6 38.6 0 0 0-15-2.4 4 4 0 0 0-3.8 3.2c-.7 4.4-2.3 11.9-.6 14.6 2.2 3.5 4.4 10.1 8 5.7s3-10.1 6.1-11.4c3.1-1.4 14.5-6.2 5.3-9.7Z",
    "data-name": "Path 47265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.8 375.6-.2-1.8-2.4-2.4-.7-3.1-2.6 1.8-1-.3-.7 2.2c2 1.1 4.2 2.6 6.1 3.9l1.5-.3Z",
    "data-name": "Path 47266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.2 425.6a4.1 4.1 0 0 1-1 .1c-.7 0-1 1-1 1l3.5 3.5c.7-.8 4-2 6.8-3.1l-.7-2.4h-1v-5.2l-1-.7-.9.4-1.2-.6-2.3 4.2a7.4 7.4 0 0 0-1.2 2.8Z",
    "data-name": "Path 47267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.4 387.3-4.6-2.2-4.4-8.3-2.7-2.7-.9-2.6-.7.2-2 .4v1.8l-.6.4-1.7 1.4-1.6.3a34.7 34.7 0 0 1 4.2 3.4q6.3 6.9 12 14.4l2-2.9 1-3.6Z",
    "data-name": "Path 47268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.4 343.9a3.7 3.7 0 0 1 2.4 3.2c.3 2.1 3.3 1.8 3.3 1.8 2 0 8.2-1.9 8.8 1.5s-2.3 4.1-4.8 4.1-4 3.2-6.2 7.2c-2 4 3.4 10 4.1 10s4-.7 4.7 1.2.6 4.4 2.1 3.8 2.8 0 5.3.2c2.5.1 2.6.6 2.6 2s-1.9 4.6-4.2 6.6c-2.3 2.1-7.6 4.1-10.7 6s-2 2.8-.4 3.1c1.6.3 5-2.8 11.7-6.4a37.4 37.4 0 0 0 13.6-12.6c2.3-3.7-1.3-1.2 0-3.7s3.5-1.9 3.7-.4c.1 1.5.6 2.5 2 2.1s6-2.8 6-3.2.6-2.9 2.1-3.4c1.5-.4 5.8 2.3 9 2.9a17.4 17.4 0 0 1 4.7 2.2l.6-2.2-1-.3.4-51c-1.8-1.1-2.3-3.2-4.8-2.6-3 .8-3.2-.1-6.4-.3s-6.4-2.1-9.5-1.7c-3.2.5-5.8-2.3-8.7-3.1s-4.3-2-7-1-7.4 3.7-9.4 4.7-3 3.5-4.2 5.9-2.5 3.3-4.5 3.4-1.8-.2-2 .4c0 0-.4 2.7 0 3.5s3.6 2.6 4.3 3.7c.7 1 1.5 2.7 2.2 3.1a14.8 14.8 0 0 1 4.3 3.9c.8 1.5-3 2-4.3 2s.2-1.8 0-2.6c-.2-.7-1.4-.9-2.3-.7-1 .2-4 2.7-6.4 4-1.2.7-1.6 1.2-1.7 1.6v.1c-.2.5.2.8.6 1Z",
    "data-name": "Path 47269"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#a)",
    opacity: 0.8,
    transform: "translate(571.4 493.5)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(162.4 222.4)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(580.4 502.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#d)",
    opacity: 0.8,
    transform: "translate(571.4 422)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(162.4 150.9)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(580.4 431)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#e)",
    opacity: 0.8,
    transform: "translate(613 624)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(203.9 352.9)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(622 633)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#f)",
    opacity: 0.8,
    transform: "translate(663.4 579.5)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(254.3 308.4)"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(672.3 588.5)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#g)",
    opacity: 0.8,
    transform: "translate(850 437)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(440.8 165.9)"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(858.8 446)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "url(#h)",
    opacity: 0.8,
    transform: "translate(810 558.7)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(408.9 295.6)"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1,
    cy: 13.1,
    r: 13.1,
    fill: "#13dbb5",
    opacity: 0.9,
    transform: "translate(829.3 578.1)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#i)",
    opacity: 0.8,
    transform: "translate(755 425.5)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(345.9 154.4)"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(764 434.5)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#j)",
    opacity: 0.8,
    transform: "translate(731 328)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(321.9 56.9)"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(740 337)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    fill: "url(#k)",
    opacity: 0.8,
    rx: 26.5,
    ry: 26,
    transform: "translate(630 514.5)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(224.9 247.4)"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.3,
    cy: 4.3,
    r: 4.3,
    fill: "#13dbb5",
    transform: "translate(652 536.5)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    fill: "url(#l)",
    opacity: 0.8,
    rx: 26.5,
    ry: 26,
    transform: "translate(769 495.5)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(363.9 228.4)"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.3,
    cy: 4.3,
    r: 4.3,
    fill: "#13dbb5",
    transform: "translate(791 517.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cb5fb",
    d: "M793.8 399.2c1.2-.1 3 1.7 2 3-1.3 1.3-3 2.5-2.3 2.9s2.6.1 1 1.1a10.3 10.3 0 0 1-5.4 1.6c-1.2-.1-4.8-.4-4.9.3s-.3 1.6-1.5 1.3a1.7 1.7 0 0 0-2 .4c-.6.4-2 0-1.4-.6.6-.6 2-3.3 3.3-3.4s3.7-.4 3-.7c-.9-.4-2.7-.2-3-.5s-2-.1-2.2-.7a1.8 1.8 0 0 1 1.1-1.7c.8-.3 1.6-2.1 1-2.5-.7-.4-1.4-1.9-.6-1.9s2.6.9 3-.2c.2-1 .5-2.6-.3-3 0 0-1.4-1.1-1-1.3s1.1-1.6.4-1.6a25.7 25.7 0 0 0-2.8.6 1.3 1.3 0 0 1-.6-1.6c.4-.8.8-2.1.2-2.1s-.9 1.2-1.4 1.3c-.3 0-.6-.6-.6-1.2s-.8-.1-1-.3c-.3-.3.3-1.1 1-1.5s0-.7-.6-.7-.7-.3 0-1 .8-1.7.4-1.9-2-.9-1.7-1.7 1.4-1.6 1.3-.8c0 .7.3.8.6.3l.8-1.6c.4-1.1-.4-2.6.7-2.7s5.6-.7 5 .4-2.2 2.6-2.2 3.1 0 .5 1.3.2c1.5-.3 3.8-.5 3.5.6s-2.3 4.2-2.4 5.1c-.2.9-.4 2.6.4 3a29.8 29.8 0 0 1 3.6 3.5c.2.3 1.8.9 1.8 1.2.1.3.2 2.7.6 3 .5.3.3 1.1.6 1.8.5.6.1.6 1.3.5m-163.2 27.5 3.5 3.5c0 .1 0 .2-.2.3-.3 1.3-1.5 2.3-.6 3.7s2 2.6-1.6 3.8-5 1-6 3.2c0 0-1.4 4.6-2.4 6s-1.3 1.8-2 1.3-1.4-1.8-.7.9c.8 2.6 2.8 4.9-1.2 7.7s-9.5 6.1-9.6 7.3-1.4 2.4-.2 6.4c1.2 3.9 3.2 11.6 1.1 11.5s-3.9-4.8-4.4-6.4c-.6-1.5-.9-6-3.7-5.9-2.9.1-9.6-1.2-11.2-.4s-1.3 1.9-5.2 1.3c-3.8-.6-8.5-.2-11.5 3.3-2.6 3-1.6 4.8-1.6 5.8l-3.7-.8-6-9.4h-2.2a8.8 8.8 0 0 1-1.9 2.4c-1 .7-2.9-2.5-3.5-3.5a11.4 11.4 0 0 0-2.5-2.4l-1.2-1.5-4.2-.1.3 1.5-7.8-.7-7.3-3.2-5 .6-.7-.6c-2.2-2.1-6.2-4-7-5.3s-5.9-8-7.8-14.7.4-19.2 0-21.3a18.2 18.2 0 0 0-1.4-5.2l3 .8.5-2.9 62.6-.2 1-1.1.6 2.4h3.7l1.3 1.6 1-.7 1 1.2 1-.7 2.6.8 1.1-.1 2.3-1.1 8.6 6.1 1.2.5 1 1.6 2.2 1.7.8 4.6s0 2.7-.4 3.1l-1.6 1.8s-.4 1.4.5 1.6a4.5 4.5 0 0 0 2.3-.3l6.2-2.8-.3-2.3 5.1-.1s1.6-2.7 2.3-2.9a8 8 0 0 0 2.1-1.5l7.7-.2Zm-155.4-57-.6 2.2a20.9 20.9 0 0 0-4.8-2.2c-3-.6-7.5-3.4-8.9-2.9-1.5.4-2.2 2.9-2.2 3.4s-4.7 2.8-6 3.2-1.8-.6-1.9-2.1c-.2-1.5-2.3-2-3.7.4-1.3 2.5 2.3 0 0 3.7a38.2 38.2 0 0 1-13.6 12.6c-6.7 3.7-10 6.8-11.7 6.4-1.6-.3-2.6-1.2.4-3.1s8.4-4 10.7-6 4.2-5.1 4.2-6.6-.2-1.9-2.6-2c-2.5-.2-3.8-.7-5.3-.2-1.5.6-1.3-1.9-2-3.8-.8-1.9-4-1.2-4.8-1.2s-6.2-6-4-10 3.6-7.2 6.1-7.2 5.4-.7 4.8-4.1-6.9-1.5-8.8-1.5c0 0-3 .3-3.3-1.8a3.7 3.7 0 0 0-2.4-3.2c-.9-.4-1.6-1.3.8-2.6s5.5-3.8 6.4-4 2.1-.1 2.3.7-1.2 2.6 0 2.6 5.1-.4 4.3-2a13.7 13.7 0 0 0-4.3-3.9c-.7-.4-1.5-2.1-2.2-3.1s-3.9-2.8-4.3-3.7 0-3.5 0-3.5c.3-.6 0-.3 2-.4s3.3-1 4.5-3.4 2.1-5 4.2-5.9c2.1-1 6.7-3.7 9.4-4.7s4.2.2 7 1c3 .8 5.5 3.5 8.7 3.1s6.4 1.4 9.5 1.7c3.2.2 3.3 1.1 6.4.3 2.5-.6 3 1.5 4.8 2.6l-.4 51 1.3.2Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#m)",
    opacity: 0.8,
    transform: "translate(603 452)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(193.9 180.9)"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    transform: "translate(612 461)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#n)",
    opacity: 0.8,
    transform: "translate(501.3 421)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(94.3 151.9)"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 12.9,
    r: 12.9,
    fill: "#13dbb5",
    transform: "translate(517.4 437.1)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#o)",
    opacity: 0.8,
    transform: "translate(792 371.4)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(384.9 102.3)"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 12.9,
    r: 12.9,
    fill: "#13dbb5",
    transform: "translate(808 387.4)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    fill: "url(#p)",
    opacity: 0.8,
    rx: 26.5,
    ry: 26,
    transform: "translate(578.3 389.8)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(414 276.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#3db6fb",
    opacity: 0.8,
    transform: "translate(173.3 122.7)"
  }))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.3,
    cy: 4.3,
    r: 4.3,
    fill: "#13dbb5",
    transform: "translate(600.3 411.8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cb5fb",
    d: "m775.7 392.2-1 1.1-.2.9 1 .8 1.1-1.2.7 1.6h.7l.5.2c.5-1.2 2.4-.7.3-4a2.4 2.4 0 0 0-2.4-.8l-.7 1.4Z",
    "data-name": "Path 47270"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cb5fb",
    d: "M777.7 380a.6.6 0 0 0 .4-.1l.1-.2a7.4 7.4 0 0 1 .4-1.4l.2-.5c0-.2-.4-.3-.6-.3a1.3 1.3 0 0 0-.6.1 1.2 1.2 0 0 0-.7.7 1.7 1.7 0 0 0 0 1v.3c0 .3.4.4.8.4Z",
    "data-name": "Path 47271"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cb5fb",
    d: "m776 382.3.2-.3c.1-.3.5-.8.5-1.1a1.2 1.2 0 0 0-.5-.5c-.4-.1-.5.2-.6.4a1.5 1.5 0 0 0 0 1.3c0 .2.2.3.4.2Z",
    "data-name": "Path 47272"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46899"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20243",
    transform: "translate(454.5 348.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#q)",
    "data-name": "Ellipse 4337",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20244",
    opacity: 0.9,
    transform: "translate(459.5 353.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#3db6fb",
    "data-name": "Ellipse 4347",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20245",
    transform: "translate(463.5 357.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    fill: "#13dbb5",
    "data-name": "Ellipse 4350"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "chart-icon",
    "data-name": "Group 47017"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(0px 20px 33px rgba(0, 0, 0, 0.5))"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    fill: "#212121",
    "data-name": "Rectangle 17531",
    rx: 30,
    transform: "translate(280 573)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M66 126.5a120.8 120.8 0 0 1-19.6-17H20.8a10.6 10.6 0 1 1 0-5H42q-3.3-4-6.2-8.3a104.6 104.6 0 0 1-8.8-16H11.7a2.5 2.5 0 1 1 0-5H25q-1.7-4.4-3-9L20.7 61H2.5a2.5 2.5 0 0 1 0-5h17.2a100.5 100.5 0 0 1-1.4-13 65 65 0 0 1 .1-9.3 2.5 2.5 0 0 1 1.8-2c6.1-2 12-4 17.2-6.2V13.1H20.8a10.6 10.6 0 1 1 0-5h19a2.5 2.5 0 0 1 2.6 2.5v12.9A108.4 108.4 0 0 0 56.3 16c6.5-4.2 9-7.1 9-7.3a2.5 2.5 0 0 1 4 0c.2.2 2.6 3.1 9.1 7.3a108.4 108.4 0 0 0 13.9 7.4v-13A2.5 2.5 0 0 1 94.8 8h19a10.6 10.6 0 1 1 0 5H97.4v12.5c5.3 2.2 11 4.2 17.2 6.1a2.5 2.5 0 0 1 1.8 2.1 65 65 0 0 1 .1 9.4A100.5 100.5 0 0 1 115 56h17.2a2.5 2.5 0 0 1 0 5H114l-1.3 5q-1.3 4.7-3 9H123a2.5 2.5 0 1 1 0 5h-15.3a104.7 104.7 0 0 1-8.8 16.1q-2.9 4.3-6.2 8.3h21.2a10.6 10.6 0 1 1 0 5H88.3a120.8 120.8 0 0 1-19.5 17 2.5 2.5 0 0 1-2.9 0Zm-26-33a109.7 109.7 0 0 0 27.4 27.8 109.7 109.7 0 0 0 27.2-27.8 99.7 99.7 0 0 0 9.1-16.7v-.1a99.8 99.8 0 0 0 4.1-11.7 98.3 98.3 0 0 0 3.6-21.9c.2-3.2.1-5.6 0-7.1A200 200 0 0 1 94 29.6h-.1a88 88 0 0 1-26.4-15.7A88 88 0 0 1 41 29.6h-.1A199 199 0 0 1 23.3 36c-.1 1.5-.2 4 0 7.1a98.4 98.4 0 0 0 3.6 22 99.9 99.9 0 0 0 4 11.5l.1.2a99.7 99.7 0 0 0 9 16.7Zm78.6 13.5a5.6 5.6 0 1 0 5.5-5.5 5.6 5.6 0 0 0-5.5 5.5ZM5 107a5.6 5.6 0 1 0 5.6-5.5A5.6 5.6 0 0 0 5 107Zm113.6-96.4A5.6 5.6 0 1 0 124 5a5.6 5.6 0 0 0-5.5 5.6ZM5 10.6A5.6 5.6 0 1 0 10.6 5 5.6 5.6 0 0 0 5 10.6ZM52.5 89a5.8 5.8 0 0 1-5.8-5.8v-23a5.8 5.8 0 0 1 5-5.8v-3.8a15.7 15.7 0 1 1 31.4 0v3.8a5.8 5.8 0 0 1 5 5.8v23a5.8 5.8 0 0 1-5.9 5.9Zm-.8-29v23.2a.8.8 0 0 0 .8.8h29.7a.8.8 0 0 0 .8-.8v-23a.8.8 0 0 0-.8-.9H52.5a.8.8 0 0 0-.8.9ZM78 54.4v-3.7a10.7 10.7 0 1 0-21.5 0v3.7ZM64.9 73.1v-2.8a2.5 2.5 0 0 1 5 0v2.8a2.5 2.5 0 0 1-5 0Z",
    "data-name": "Union 8",
    transform: "translate(312.1 609)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "chart-spider",
    "data-name": "Group 47023"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(0px 20px 33px rgba(0, 0, 0, 0.5))"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 415,
    fill: "#212121",
    "data-name": "Rectangle 17864",
    rx: 30,
    transform: "translate(99 116)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.8 160.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m303.2 247.6 30-37.6Zm30-37.6-11.8-51.7 11.8 51.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M92.5 325.8.7 210.8l91.8 115Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M159.5 4.7 33 65.5 1.8 202.2 33 65.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M218 26 174 4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M33 65.5 1.8 202.2 0 210l.8 1-.6-1.6 1.7-.5L34.1 67.6l-1.1-.8.9-1.3 1.1.8L159.5 6.4V4.7L33 65.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m299.1 67.8 32.4 141.8-91 114 .6 1.4-1.4.6-.6-1.4H94.8l-.6 1.3-1.4-.6.3-.8L2.3 210.4l-1.6.5 91.8 115h148.3l62.5-78.3 30-37.6-11.8-51.7-20.9-91.5-1.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m174 6.5 124.4 59.9 1.2-.9.9 1.2-.3-1.2L218 26 174 4.8v1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m226.6 293 71.9-90.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m299.5 201.4.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M157.2 38.2 60.4 84.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m59.9 86.4-18.7 82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "m35.7 199.4 25.5-112-1.4-1-18.7 82-7.1 31.5 1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "m271.9 85.8 1.4-1.1-97-46.7v1.8l95.6 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m36.1 200.9-1.6.5 72.9 91.4.7-1.6-72-90.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "m109.4 291.8-.7 1.6H225l-.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M157.2 40v-1.8L60.4 84.9l1.4 1.1 95.4-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "m272.7 87.1 25.8 113.1-.6.7 1.6.5.6-.8-26-114.5-1.4 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "m225.9 291.4.7 1.6 71.9-90.2-1.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "m87 106.3-14.9 65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m160.6 70.1-13.1 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "m211.1 259.2 52.8-66.5-52.8 66.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m160.6 70.1-13.1 6.3-59.4 28.7 1.4 1.1 71.1-34.3v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "m69.6 189.9 18.8-82.6-1.4-1-14.9 65.6-4.2 18.4a10.5 10.5 0 0 0 1.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "m69.7 191.5-1.6.5 54.1 68 .7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M209.2 258.8h-84.8l-.7 1.6H210Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "m263.2 190.9 1.7.5-19.2-84.6-1.4 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "m243.6 106.4 1.4-1.1-72.1-34.8v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "m211.1 259.2 52.8-66.5-1.6-.5-51.9 65.3.7 1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M119.2 129.9 108 179.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "m215.4 136.2-1.4-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "m213.3 128.5-35.7-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "m177.6 112.9 34.2 16.6 1.4-1.1-35.7-17.3a11.5 11.5 0 0 1 .1 1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M155.9 112.8V111L120 128.5l1.4 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M141.4 221.2h50.7l-.7-1.6h-49.3l-.7 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "m212.6 130.9 11 48.4 1.7.5-9.9-43.6-1.4-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "m110 180.2-1.6.5 31.6 39.9.7-1.6-30.7-38.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M119.2 129.9 108 179.2l1.7-.5 10.8-47.8-1.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "m192.7 218.8.7 1.6 31-39.2-1.6-.5-30.1 38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "m147 150.2-4.2 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "m187.3 154.6-1-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "m143 171 12.5 15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "m157.9 144.5-9.7 4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M157.9 146.2v-1.7l-9.7 4.6 1.4 1.1 8.3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M157 186.7h19.4l-.7-1.6h-17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "m177.1 184.6.7 1.6 12.2-15-1.6-.5-11.3 13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "m144.2 169 4.1-17.8-1.4-1-4.2 18-.3 1.3 1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "m183.6 150.1 1.4-1.1-9.5-4.5v1.7l8.1 3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "m184.9 151.2 4.2 18.1 1.7.5-3.5-15.1-1-4.4-1.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "m144.6 170.5-1.6.5 12.5 15.3.7-1.6-11.6-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M300.5 66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "m298.4 66.4-25.1 18.3.5.2.3 1.1 25.1-18.3-.3-1.2-.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M300.5 66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "m299.6 65.5-1.2.9.5.2.3 1.2 1.4-1v-.1l-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M271.9 85.8 245 105.3l.4.2.3 1.2L272.6 87l-.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "m273.3 84.7.5.2.3 1.1-.3-1.1-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "m272.5 86.1.2 1.1 1.4-1-.3-1.1-.5-.2-1.5 1.1.7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "m245 105.3.4.2.3 1.2-.3-1.2-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "m213.8 128.7.3 1.2 30.3-22.1-.3-1.2-.5-.2-30.3 22.1.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "m244.1 106.6.3 1.2 1.4-1-.3-1.2-.4-.2-1.4 1.1.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M211.9 129.5 185.1 149l1 .5.1.7 26.4-19.3-.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "m213.8 128.7.3 1.2-.3-1.2-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "m212.4 129.8.3 1.1 1.4-1-.3-1.2-.4-.2-1.4 1.1.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "m167.4 162.9 1 .3 16.5-12-.1-.6-1.1-.5-16.3 11.9v.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "m186.1 149.5-1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "m186.2 150.2-.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "m183.6 150.1 1.1.5.1.6 1.4-1-.1-.7-1-.5-1.5 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "m331.2 210.8.4-1.5-32.1-7.8-1.1 1.3 32.8 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "m265 191.5-1 1.3 32.9 9.6 1.1-1.3-33-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "m298.5 202.8 1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "m298.5 202.8 1.1-1.3-1.6-.5-1.1 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M265 191.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "m225.4 180.1-.9 1.2 37.9 11 .9-1.2v-.2l-37.9-11.1v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "m264 192.7 1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M263.2 190.9v.2l-.9 1.2 1.6.5 1-1.3v-.1l-1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "m225.4 180.1-.9 1.2.9-1.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "m190.9 170.2-.8 1 32.8 9.6.9-1.1-.1-.3-32.8-9.6v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "m222.8 180.7 1.6.5.9-1.2-.1-.2-1.7-.5.1.3-.8 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "m167.6 163.8.4 1 20.4 5.9.8-.9-.1-.5-20.7-6-.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "m190.9 170.2-.8 1 .8-1-.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "m188.4 170.7 1.6.5.8-1-.1-.4-1.7-.5.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "m167.6 163.8.8-.6-1-.3v.4l.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M226.3 293.4H225l14.1 30.9h.9l.5-.7-14-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M240 324.3h-.9l.6 1.4 1.4-.6-.6-1.4-.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M210.2 260.4h-.2l14.4 31.5h1.2l.3-.4-14.7-32.2-1 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "m226.3 293.4.3-.4-.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M225.5 291.8h-1.2l.7 1.6h1.3l.3-.4-.7-1.6-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M192.8 221.2h-.7l17.1 37.5h.2l.9-1.2-17-37.2-.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M209.9 260.4h.3l.9-1.1-.9 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M209.5 258.8h-.2l.7 1.6h.3l.9-1.1-.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M177.4 186.7h-1.1l15 32.9h.6l.7-.9-14.9-32.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.1,
    fill: "#fff",
    transform: "translate(193.1 220.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M192 219.7h-.6l.7 1.6h.7l.7-.8-.7-1.6-.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "m166.6 165.4 9 19.7h1.1l.4-.5-9.1-19.8-1-.3-.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "m177.4 186.7.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M176.7 185.1h-1.1l.7 1.6h1.1l.4-.5-.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "m167.1 164.5 1 .3-.4-1-.4.3-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M167.4 163.5h-.8l.7.3-.1.2.4-.3-.2-.4v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M0 0h1.6v21.2H0z",
    transform: "translate(165.8 10.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M0 0h1.6v19.7H0z",
    transform: "translate(165.8 43.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M0 0h1.6v27.5H0z",
    transform: "translate(165.8 74.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M0 0h1.6v22.8H0z",
    transform: "translate(165.8 114)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "m165.8 162 .8.6.8-.6v-13.4h-1.6V162Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "m166.6 162.6.4.3.4.1v-1l-.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "m167.1 162.9-.5.6.7-.3.1.1v-.4l-.4-.1.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M166.6 163.5Zm0 0h.8v-.2l-.1-.1-.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "m107.7 293.4-.5-.6L93 324.1l.1.1h1.5l14-30.9-.9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "m92.8 324.9 1.4.6.6-1.3h-1.5l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "m122.4 260.4-.3-.4-14.1 31.2.5.6h.9l14.2-31.5-1.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "m107.3 292.8.5.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "m108.5 291.8-.5-.6-.7 1.6.5.6h1l.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "m140.5 221.2-.5-.6-17.1 37.8.3.4h1.2l17-37.5-.9-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "m122.1 260 .3.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "m123.2 258.8-.3-.4-.7 1.6.3.4h1.3l.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "m139.9 220.6.5.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "m155.8 186.7-.4-.4-14.7 32.7.6.7h.9l14.9-32.9-1.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bA)",
    d: "M142.1 219.7h-.9l-.6-.7-.7 1.6.5.6h.9l.8-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M155.8 186.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "m166.2 164.5-1 .3-9 19.9.4.5h1.1l8.9-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "m155.8 186.7-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M157.7 185.1h-1.1l-.4-.5-.7 1.6.4.4h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "m166.2 164.5.4 1 .4-1-.4-.1-.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "m166.6 163.5.2.8-.2.1.4.1.2-.4-.2.1-.4-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "m166.6 163.5.5.6.2-.1.1-.2-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "m33.8 200.6.2-.8-33.8 9.5.5 1.5 1.6-.5 32.1-9-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "m33.8 200.6.2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "m67.7 191.5.2-1.1-32.2 9-.2.9.5.7 32-9-.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "m34.4 201.4-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "m36.1 200.9-.5-.7.2-.9-1.7.5-.2.8.6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "m67.7 191.5.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "m107.8 180.1.2-.9L69.6 190l-.3 1.2.3.4 38.6-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "m68.1 192-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "m69.7 191.5-.3-.4.3-1.2-1.7.5-.2 1.1.4.5 1.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "m142.4 170.2.2-.7-32.7 9.2-.2 1 .4.6 33-9.2-.7-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "m108.3 180.7-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "m107.8 180.1.2-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "m110 180.2-.4-.6.2-1-1.7.5-.2.9.5.6 1.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "m142.4 170.2.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "m165.6 163.8-.8-.6-20.6 5.8-.2.8.6.7 20.6-5.8.4-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "m143 171-.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "m144.6 170.5-.6-.7.2-.8-1.7.5-.2.7.6.8 1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "m166 164.1-.4-.3-.4.9 1-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "m166.1 164.2-.2-.1.2.4.4-.1-.2-.1.2-.8-.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "m166.4 164.3.2.1.2-.1-.2-.8-.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "m60.2 85 .2-.1L35 66.3l-.6.3-.2 1 25.7 18.8.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "m35 66.3-1.1-.8-.9 1.3 1.2.9.2-1 .6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "m87.2 105.6.9-.4-26.3-19.3-.3.1-.3 1.4L87 106.3a6.4 6.4 0 0 1 .2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "m59.9 86.4.3-1.5Zm.5-1.5-.2.1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "m61.8 85.9-1.4-1.1-.2.2-.3 1.5 1.4 1 .3-1.4.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "m87.2 105.6.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "m119.5 128.7.5-.2-30.5-22.3-.9.5-.2.7 30.8 22.5.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ci)",
    d: "m87 106.3.2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "m88.4 107.3.2-.7.9-.5-1.4-1.1-.9.4-.2.8 1.4 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ck)",
    d: "m148.2 149.1-26.7-19.6-.6.3-.2 1.1 26.4 19.3.1-.6 1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "m119.5 128.7-.3 1.1.3-1.1.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cm)",
    d: "m120.8 129.8.6-.3-1.4-1.1-.5.2-.3 1.1 1.4 1 .2-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M165.8 162.9v-.9l-16.2-11.9-1.1.5-.1.6 16.5 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#co)",
    d: "m147.2 149.5 1-.5-1 .5-.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "m149.6 150.1-1.4-1.1-1 .5-.1.6 1.4 1 .1-.6 1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cq)",
    d: "m166.6 162.6-.8-.6v.9l.4-.1.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M166.3 162.8h.1l.2.8.2-.8h.1l-.4-.3-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cs)",
    d: "m166.6 163.5.5-.6-.1-.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "m165.8 162.9-1 .3.8.6.2-.4v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cu)",
    d: "M165.8 162.9v.4l.1-.1.7.3-.5-.6.1-.1-.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cv)",
    d: "m166.3 162.8-.1.1.5.6-.2-.8-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "m165.6 163.8.4.3-.1-.2.7-.3h-.8v-.2l-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "m165.9 163.9.1.2.2.1.5-.6-.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cy)",
    d: "M165.8 163.4v.2h.8l-.7-.3-.1.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3eb6fb",
    "data-name": "Group 47032"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.6 144.5v-5l-1 1-.4-.5 1.5-1.6h.7v6h-.8Z",
    "data-name": "Path 47077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 138.4c1.6 0 2.3 1.6 2.3 3.1s-.7 3.1-2.3 3.1-2.3-1.6-2.3-3.1.7-3.1 2.3-3.1Zm0 .7c-1.1 0-1.5 1.2-1.5 2.4s.4 2.4 1.5 2.4 1.5-1.2 1.5-2.4-.3-2.4-1.5-2.4Z",
    "data-name": "Path 47078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3 138.4c1.6 0 2.3 1.6 2.3 3.1s-.7 3.1-2.3 3.1-2.3-1.6-2.3-3.1.7-3.1 2.3-3.1Zm0 .7c-1.1 0-1.5 1.2-1.5 2.4s.4 2.4 1.5 2.4 1.5-1.2 1.5-2.4-.3-2.4-1.5-2.4Z",
    "data-name": "Path 47079"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3eb6fb",
    "data-name": "Group 47033"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.4 108.6a2 2 0 0 0 1.7.8 1.3 1.3 0 0 0 1.4-1.3 1.3 1.3 0 0 0-1.4-1.3 2 2 0 0 0-1.4.6l-.6-.2V104h3.7v.7h-2.9v2.1a2 2 0 0 1 1.4-.5 1.8 1.8 0 0 1 1.9 1.9 2 2 0 0 1-2.1 2 2.4 2.4 0 0 1-2.1-1l.4-.6Z",
    "data-name": "Path 47080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4 103.8c1.6 0 2.3 1.6 2.3 3.1s-.7 3.1-2.3 3.1-2.3-1.7-2.3-3.1.6-3.1 2.3-3.1Zm0 .7c-1.1 0-1.5 1.2-1.5 2.4s.4 2.4 1.5 2.4 1.5-1.2 1.5-2.4-.4-2.4-1.5-2.4Z",
    "data-name": "Path 47081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9 103.8c1.6 0 2.3 1.6 2.3 3.1s-.7 3.1-2.3 3.1-2.3-1.7-2.3-3.1.6-3.1 2.3-3.1Zm0 .7c-1.1 0-1.5 1.2-1.5 2.4s.4 2.4 1.5 2.4 1.5-1.2 1.5-2.4-.4-2.4-1.5-2.4Z",
    "data-name": "Path 47082"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3eb6fb",
    "data-name": "Group 47034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.2 39.1v-5l-1 1-.4-.5 1.5-1.5h.7v6Z",
    "data-name": "Path 47083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1 40c.3-.2.6-.5.6-.8h-.1a.5.5 0 0 1-.4-.5.5.5 0 0 1 .5-.5c.3 0 .6.2.6.7a2 2 0 0 1-.7 1.4l-.5-.3Z",
    "data-name": "Path 47084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 37.8a2 2 0 0 0 1.7.8 1.3 1.3 0 0 0 1.4-1.3 1.3 1.3 0 0 0-1.4-1.3 2 2 0 0 0-1.4.6l-.6-.2v-3.2h3.7v.7h-2.9V36a2 2 0 0 1 1.4-.5 1.8 1.8 0 0 1 1.9 1.9 2 2 0 0 1-2.1 2 2.4 2.4 0 0 1-2.1-1l.4-.6Z",
    "data-name": "Path 47085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.3 39.1-2.3-2.7-.6.7v2h-.8v-6h.8v3.1l2.7-3.1h.9l-2.5 2.8 2.7 3.2Z",
    "data-name": "Path 47086"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3eb6fb",
    "data-name": "Group 47035"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.1 70.6v-5l-1 1-.4-.5 1.5-1.6h.7v6a2.5 2.5 0 0 1-.8.1Z",
    "data-name": "Path 47087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.8 70.6-2.3-2.7-.6.7v2h-.8v-6h.8v3.1l2.7-3.1h.9l-2.5 2.8 2.7 3.2Z",
    "data-name": "Path 47088"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3eb6fb",
    "data-name": "Group 47036"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.8 6.1v-.6c2.2-1.7 3.3-2.7 3.3-3.7a1 1 0 0 0-1.2-1.1 1.8 1.8 0 0 0-1.6.8l-.5-.5a2.6 2.6 0 0 1 2.1-.9 1.8 1.8 0 0 1 2 1.8c0 1.2-1.2 2.3-2.9 3.7h2.9v.7l-4.1-.2Z",
    "data-name": "Path 47089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.9 6.1-2.3-2.7-.6.7v2h-.8v-6h.8v3.1l2.7-3.1h.9l-2.5 2.8 2.7 3.2Z",
    "data-name": "Path 47090"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#13dbb5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.6 196.1 31.2-95.7.9.2 86.6 16.9 105.4-32.6L332.8 210l-139.5 10.7-96.1 97.4-.6-1.4-47-120.6Zm32.5-93.4-30.4 93.4L98 314.5l94.4-95.8h.4l137.5-10.5-57.7-120.9-104.3 32.2-.2-.1-86-16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.6 316 93.8-95.3 139.8-11-59-123.2L168.3 118l-85.8-17-31.8 94.5L98.6 316Z",
    opacity: 0.3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "chart-data",
    "data-name": "Group 46927"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(0px 20px 33px rgba(0, 0, 0, 0.5))"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 447,
    height: 113,
    fill: "#212121",
    "data-name": "Rectangle 17531",
    rx: 30,
    transform: "translate(410 79)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 47025",
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m465.9 124.2-5.3-13.4h2.7l4 10.8 4-10.8h2.7l-5.2 13.4h-3Z",
    "data-name": "Path 47038"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.2 111.6a1.3 1.3 0 1 1 1.3 1.3 1.3 1.3 0 0 1-1.3-1.3Zm.2 12.6v-9.7h2.1v9.7Z",
    "data-name": "Path 47039"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M484.5 114.3c3 0 4.8 2.2 4.8 5.2v.5h-7.5a3 3 0 0 0 3.1 2.7 4 4 0 0 0 2.8-1l1 1.3a5.6 5.6 0 0 1-4 1.4 4.9 4.9 0 0 1-5-5 4.9 4.9 0 0 1 4.8-5.1Zm-2.7 4.2h5.5a2.6 2.6 0 0 0-2.8-2.5 2.7 2.7 0 0 0-2.7 2.5Z",
    "data-name": "Path 47040"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m499.8 124.2-2.2-7.1-2.3 7h-2.2l-3-9.6h2.2l2 7 2.3-7h1.9l2.3 7 2-7h2.2l-3 9.7Z",
    "data-name": "Path 47041"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M506.6 121.4a5 5 0 0 0 3.3 1.3c1.2 0 1.9-.4 1.9-1.1 0-.9-1-1.2-2.2-1.4-1.7-.4-3.7-.8-3.7-3 0-1.6 1.4-3 3.8-3a5.5 5.5 0 0 1 3.8 1.4l-1 1.5a3.9 3.9 0 0 0-2.8-1.2c-1 0-1.8.4-1.8 1.1 0 .8 1 1 2.1 1.3 1.7.3 3.8.8 3.8 3.1 0 1.7-1.4 3-4 3a5.9 5.9 0 0 1-4.2-1.5l1-1.5Z",
    "data-name": "Path 47042"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 47026",
    style: {
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M587 110.6a6.6 6.6 0 0 1 6.9 6.9 6.8 6.8 0 1 1-13.7 0 6.6 6.6 0 0 1 6.9-6.9Zm0 2c-2.6 0-4.4 2.1-4.4 4.9s1.8 4.8 4.5 4.8 4.4-2 4.4-4.8-1.8-4.8-4.4-4.8Z",
    "data-name": "Path 47043"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M598.2 127.8H596v-13.3h2v1.3a3.9 3.9 0 0 1 3.2-1.5c2.5 0 4.3 1.8 4.3 5s-1.8 5.1-4.3 5.1a3.8 3.8 0 0 1-3.1-1.6Zm2.5-11.7a3.1 3.1 0 0 0-2.5 1.3v3.8a3.2 3.2 0 0 0 2.5 1.3c1.6 0 2.7-1.3 2.7-3.2s-1-3.2-2.7-3.2Z",
    "data-name": "Path 47044"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M612 114.3c2.9 0 4.7 2.2 4.7 5.2v.5h-7.4a3 3 0 0 0 3 2.7 4 4 0 0 0 2.8-1l1 1.3a5.6 5.6 0 0 1-4 1.4 4.9 4.9 0 0 1-5-5 4.9 4.9 0 0 1 4.9-5.1Zm-2.7 4.2h5.4a2.6 2.6 0 0 0-2.7-2.5 2.7 2.7 0 0 0-2.7 2.5Z",
    "data-name": "Path 47045"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M625.3 124.2v-6c0-1.6-.7-2-1.9-2a3.2 3.2 0 0 0-2.5 1.2v6.8h-2v-9.7h2v1.3a4.6 4.6 0 0 1 3.4-1.5 2.8 2.8 0 0 1 3.1 3v6.9h-2Z",
    "data-name": "Path 47046"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M630.3 121.4a5 5 0 0 0 3.3 1.3c1.2 0 1.9-.4 1.9-1.1 0-.9-1-1.2-2.2-1.4-1.7-.4-3.7-.8-3.7-3 0-1.6 1.4-3 3.8-3a5.5 5.5 0 0 1 3.8 1.4l-.9 1.5a3.9 3.9 0 0 0-2.9-1.2c-1 0-1.8.4-1.8 1.1 0 .8 1 1 2.1 1.3 1.7.3 3.8.8 3.8 3.1 0 1.7-1.4 3-4 3a5.9 5.9 0 0 1-4.2-1.5l1-1.5Z",
    "data-name": "Path 47047"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 47027",
    style: {
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M715.7 124.2v-13.4h6.5c2.5 0 3.8 1.5 3.8 3.4a3 3 0 0 1-2.3 3 3.3 3.3 0 0 1 2.6 3.4c0 2-1.4 3.6-3.9 3.6h-6.7Zm2.3-7.9h3.8a1.7 1.7 0 0 0 1.8-1.7 1.7 1.7 0 0 0-1.8-1.7H718Zm0 5.8h3.9a1.8 1.8 0 0 0 2-1.9 1.8 1.8 0 0 0-2-1.8H718Z",
    "data-name": "Path 47048"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M735 124.2v-1.3a4.6 4.6 0 0 1-3.3 1.5c-2.1 0-3.1-1-3.1-3v-6.9h2v6c0 1.6.8 2 2 2a3.2 3.2 0 0 0 2.5-1.2v-6.8h2v9.7Z",
    "data-name": "Path 47049"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M740.3 122v-5.7h-1.6v-1.8h1.6v-2.6h2.1v2.6h2v1.8h-2v5.1c0 .7.4 1.1 1 1.1a1.4 1.4 0 0 0 .9-.3l.5 1.6a2.8 2.8 0 0 1-2 .6 2.2 2.2 0 0 1-2.5-2.5Z",
    "data-name": "Path 47050"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M746.7 122v-5.7h-1.6v-1.8h1.6v-2.6h2.1v2.6h2v1.8h-2v5.1c0 .7.3 1.1 1 1.1a1.4 1.4 0 0 0 .9-.3l.5 1.6a2.8 2.8 0 0 1-2 .6 2.2 2.2 0 0 1-2.5-2.5Z",
    "data-name": "Path 47051"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M752 119.3a5 5 0 1 1 10 0 5 5 0 1 1-10 0Zm7.8 0c0-1.7-1-3.2-2.8-3.2s-2.7 1.5-2.7 3.2 1 3.2 2.7 3.2 2.8-1.5 2.8-3.2Z",
    "data-name": "Path 47052"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M770.7 124.2v-6c0-1.6-.8-2-2-2a3.2 3.2 0 0 0-2.5 1.2v6.8h-2v-9.7h2v1.3a4.6 4.6 0 0 1 3.4-1.5 2.8 2.8 0 0 1 3.2 3v6.9h-2.1Z",
    "data-name": "Path 47053"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M780 117.5a6.7 6.7 0 0 1 7-6.9 6 6 0 0 1 5.4 3l-2 1a4 4 0 0 0-3.4-2 4.5 4.5 0 0 0-4.5 4.9 4.5 4.5 0 0 0 4.5 4.8 4 4 0 0 0 3.4-2l2 1.1a6.1 6.1 0 0 1-5.4 3 6.7 6.7 0 0 1-7-6.9Z",
    "data-name": "Path 47054"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M794.3 124.2v-13.4h2v13.4Z",
    "data-name": "Path 47055"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M798.8 111.6a1.3 1.3 0 1 1 1.3 1.3 1.3 1.3 0 0 1-1.3-1.3Zm.3 12.6v-9.7h2v9.7Z",
    "data-name": "Path 47056"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M808.3 114.3a4.3 4.3 0 0 1 3.7 1.7l-1.4 1.3a2.6 2.6 0 0 0-2.2-1.2 3 3 0 0 0-3 3.2 3 3 0 0 0 3 3.2 2.6 2.6 0 0 0 2.2-1.1l1.4 1.3a4.3 4.3 0 0 1-3.7 1.7 4.9 4.9 0 0 1-5-5 4.8 4.8 0 0 1 5-5.1Z",
    "data-name": "Path 47057"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m820.2 124.2-3-4-1.3 1.4v2.6h-2v-13.4h2v8.4l4.3-4.7h2.6l-4 4.4 4 5.3h-2.6Z",
    "data-name": "Path 47058"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M824.3 121.4a5 5 0 0 0 3.3 1.3c1.2 0 1.9-.4 1.9-1.1 0-.9-1-1.2-2.2-1.4-1.7-.4-3.7-.8-3.7-3 0-1.6 1.4-3 3.8-3a5.5 5.5 0 0 1 3.8 1.4l-1 1.5a3.9 3.9 0 0 0-2.8-1.2c-1 0-1.8.4-1.8 1.1 0 .8 1 1 2.1 1.3 1.7.3 3.8.8 3.8 3.1 0 1.7-1.4 3-4 3a5.9 5.9 0 0 1-4.2-1.5l1-1.5Z",
    "data-name": "Path 47059"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#7a849c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563 125.5a1 1 0 0 1-1-.7l-5.2-12.7a1 1 0 0 1 .2-1 1 1 0 0 1 1.1-.3l12.7 5.3a1 1 0 0 1 .7 1 1 1 0 0 1-.7.9l-5.1 1.7-1.7 5a1 1 0 0 1-1 .8Zm-3.4-12 3.3 8.1 1-3a1 1 0 0 1 .7-.6l3-1-8-3.4Z",
    "data-name": "Path 47060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.7 124.7a1 1 0 0 1-.7-.3l-4.5-4.5a1 1 0 0 1 1.4-1.4l4.5 4.5a1 1 0 0 1 0 1.4 1 1 0 0 1-.7.3Z",
    "data-name": "Path 47061"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3db6fb",
    "data-name": "Group 47028",
    style: {
      isolation: "isolate"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M443 162.8v-14.5l-3.2 3.4-2.5-2.5 6.3-6.4h3.7v20h-4.2Z",
    "data-name": "Path 47062"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M453.2 158.3a2.4 2.4 0 1 1-2.5 2.4 2.5 2.5 0 0 1 2.5-2.4Z",
    "data-name": "Path 47063"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M460.8 157.3a7.3 7.3 0 0 0 5.4 2.2c2.3 0 3.7-1.4 3.7-3 0-1.8-1.3-3-3.6-3a5.8 5.8 0 0 0-4.2 1.6l-3-.8v-11.5h13.7v3.7h-9.5v5a6.9 6.9 0 0 1 4.5-1.6 6.2 6.2 0 0 1 6.4 6.4c0 4-3.2 7-8 7a10 10 0 0 1-7.7-3l2.3-3Z",
    "data-name": "Path 47064"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M494.6 162.8v-14.4l-5.6 14.4h-2l-5.6-14.4v14.4h-4.3v-20h6l4.9 12.5 4.8-12.5h6v20h-4.3Z",
    "data-name": "Path 47065"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3db6fb",
    "data-name": "Group 47029",
    style: {
      isolation: "isolate"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m559.6 162.8 7.1-16.2h-10v-3.8h15v3l-7.5 17h-4.6Z",
    "data-name": "Path 47066"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M573.7 162.8v-3.3c8.2-6 10.6-8.1 10.6-10.6 0-1.7-1.6-2.6-3.3-2.6a7.1 7.1 0 0 0-5.3 2.3l-2.5-2.8a10.2 10.2 0 0 1 7.7-3.3c4.3 0 7.7 2.4 7.7 6.4 0 3.4-2.8 6.4-8.2 10.2h8.3v3.7Z",
    "data-name": "Path 47067"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M600.6 162.8v-4H591v-3.5l8-12.5h5.9V155h2.5v3.7H605v4.2h-4.3Zm0-16.2-5.4 8.4h5.4Z",
    "data-name": "Path 47068"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3db6fb",
    "data-name": "Group 47030",
    style: {
      isolation: "isolate"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M681.2 162.8v-3.3c8.2-6 10.6-8.1 10.6-10.6 0-1.7-1.6-2.6-3.3-2.6a7.1 7.1 0 0 0-5.4 2.3l-2.4-2.8a10.2 10.2 0 0 1 7.7-3.3c4.3 0 7.7 2.4 7.7 6.4 0 3.4-2.8 6.4-8.2 10.2h8.3v3.7h-15Z",
    "data-name": "Path 47069"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M703 152.5c-2.1-.7-3.9-2.2-3.9-4.7 0-3.7 4-5.3 7.7-5.3s7.8 1.6 7.8 5.3c0 2.5-1.8 4-4 4.7 2.4.9 4.3 2.7 4.3 5.2 0 3.7-3.9 5.5-8 5.5s-8-1.8-8-5.5c-.1-2.5 1.8-4.3 4.2-5.2Zm3.8 2c-1.2 0-3.7 1-3.7 2.6 0 1.5 1.6 2.4 3.7 2.4s3.8-.9 3.8-2.4c0-1.7-2.5-2.5-3.8-2.7Zm0-8.3c-2 0-3.3.9-3.3 2.3 0 1.5 2.1 2.2 3.3 2.4 1.3-.2 3.4-.9 3.4-2.4 0-1.4-1.4-2.3-3.4-2.3Z",
    "data-name": "Path 47070"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M726.3 142.5a9 9 0 0 1 5.9 2.1l-2 3.2a5.3 5.3 0 0 0-4-1.6c-3 0-5 2.6-5 5.8a1.8 1.8 0 0 0 .1.4 6.5 6.5 0 0 1 5.1-2.5c3.6 0 6.8 2.2 6.8 6.4 0 4-3 7-7.6 7-6.1 0-8.6-4.8-8.6-10.4 0-6 3.4-10.4 9.3-10.4Zm-1.1 11a5.1 5.1 0 0 0-3.9 1.9c.2 1.9 1.3 4 4 4 2.4 0 3.6-1.5 3.6-2.9 0-2.1-1.7-3-3.7-3Z",
    "data-name": "Path 47071"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cA)",
    "data-name": "Group 47031",
    transform: "translate(436 109)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7a849c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.3 13.7h-.2a1 1 0 0 1 0-2h.2a3.4 3.4 0 0 0 0-6.8h-13.2a3.4 3.4 0 0 0 0 6.8h9.3a1 1 0 0 1 0 2h-9.3a5.4 5.4 0 0 1 0-10.8h13.2a5.4 5.4 0 0 1 0 10.8Z",
    "data-name": "Path 47072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4 21a1 1 0 0 1-1-.6l-3.8-9.2a1 1 0 0 1 .2-1 1 1 0 0 1 1.1-.3l9.2 3.8a1 1 0 0 1 .6 1 1 1 0 0 1-.7 1l-3.5 1.1-1.2 3.5a1 1 0 0 1-1 .7Zm-2-8.3 1.9 4.5.5-1.5a1 1 0 0 1 .6-.6l1.5-.5-4.5-2Z",
    "data-name": "Path 47073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2 20.5a1 1 0 0 1-.7-.3l-3.3-3.3a1 1 0 0 1 1.4-1.4l3.3 3.3a1 1 0 0 1 0 1.4 1 1 0 0 1-.7.3Z",
    "data-name": "Path 47074"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#7a849c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.3 124c-5.2 0-8-5.6-8.2-5.8a1 1 0 0 1 0-1c.1-.2 3-5.8 8.2-5.8s8.1 5.6 8.2 5.9a1 1 0 0 1 0 .9c-.1.2-3 5.8-8.2 5.8Zm-6.2-6.3c.8 1.2 3 4.4 6.2 4.4s5.4-3.2 6.2-4.4c-.8-1.2-3-4.3-6.2-4.3s-5.4 3.1-6.2 4.3Z",
    "data-name": "Path 47075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3 120.7a3 3 0 1 1 0-6 3 3 0 0 1 2.1 1 3 3 0 0 1 .9 2 3 3 0 0 1-3 3Zm0-4a1 1 0 1 0 1 1 1 1 0 0 0-.3-.7 1 1 0 0 0-.7-.3Z",
    "data-name": "Path 47076"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#78849e",
    d: "M0 0h1v54.9H0z",
    "data-name": "Rectangle 17866",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    transform: "translate(535.5 109)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78849e",
    d: "M0 0h1v54.9H0z",
    "data-name": "Rectangle 17867",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    },
    transform: "translate(659.3 109)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.9231fb54fc079c7becc449ae47557301.svg";
export { ForwardRef as ReactComponent };